<template>
<div class="report-wrapper">
  <ModalLoading :isLoading="isLoading" />

  <div class="report-body">
    <div class="main-content">
      <!-- Sección de filtros -->
      <div class="filters-section">
        <div class="filter-row">
          <div class="filter-group">
            <label>Tipo de Reporte</label>
            <select v-model="reporteSeleccionado" class="select-input">
  <option value="ventas_cliente">Ventas por Cliente</option>
  <option v-if="esCeo" value="ventas_sucursal">Ventas por Sucursal</option>
  <option value="ventas_empleado">Ventas por Empleado</option>
  <option value="productos_vendidos">Productos Más Vendidos</option>
  <option value="clientes_frecuentes">Clientes Frecuentes</option>
  <option value="ventas_por_hora">Ventas por Hora</option>
  <option value="metodos_pago">Métodos de Pago</option>
  <option value="ventas_canceladas">Ventas Canceladas</option>
  <option value="devoluciones">Devoluciones / Notas de Crédito</option>
  <option value="anulaciones">Anulaciones</option>
  <option value="reporte_compras">Reporte de Compras</option>
  <option value="reporte_fiscal">Reporte Fiscal de Ventas</option>
  <option value="facturas_sin_sar">Facturas Pendientes de Validación SAR</option>
  <option value="utilidad_bruta">Utilidad Bruta</option>
  <option value="rotacion_inventario">Rotación de Inventario</option>
  <option value="comparativo_mensual">Comparativo Mensual</option>
  <option value="proyeccion_ventas">Proyección de Ventas</option>
  <option value="ordenes_produccion">Órdenes de Producción</option>
  <option value="margen_produccion">Rendimiento por Receta</option>
</select>
          </div>

          <div class="filter-group" v-if="showEntityFilter">
            <label>{{ labelFiltro }}</label>
            
            <!-- ✅ SIEMPRE usar SELECT para sucursales (ventas_sucursal y CEO en otros reportes) -->
            <select 
              v-if="reporteSeleccionado === 'ventas_sucursal' || (esCeo && !['ventas_cliente', 'ventas_empleado'].includes(reporteSeleccionado))" 
              v-model="valorFiltro" 
              class="select-input"
            >
              <option value="">{{ defaultSelectText }}</option>
              <option
                v-for="opcion in opcionesFiltro"
                :key="opcion.id"
                :value="opcion.id"
              >
                {{ opcion.nombre }}
              </option>
            </select>

            <!-- Para ventas_cliente y ventas_empleado usar datalist -->
            <div v-else>
              <input 
                type="text" 
                v-model="valorFiltroTexto"
                :list="'datalist-' + reporteSeleccionado"
                class="select-input"
                :placeholder="'Buscar ' + labelFiltro.toLowerCase() + '...'"
                @input="handleDatalistInput"
              />
              <datalist :id="'datalist-' + reporteSeleccionado">
                <option value="">{{ defaultSelectText }}</option>
                <option
                  v-for="opcion in opcionesFiltro"
                  :key="opcion.id"
                  :value="opcion.nombre"
                  :data-id="opcion.id"
                >
                </option>
              </datalist>
            </div>
          </div>

          <div class="filter-group" v-if="showAdvancedFilters">
            <label>Límite de Registros</label>
            <select v-model="filtros.limite" class="select-input">
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
              <option value="1000">1000</option>
            </select>
          </div>

          <div class="filter-group" v-if="reporteSeleccionado === 'rotacion_inventario'">
            <label>Días sin ventas</label>
            <input v-model.number="diasRotacion" type="number" min="1" class="select-input" style="width:130px" />
          </div>

          <div class="filter-group" v-if="reporteSeleccionado === 'proyeccion_ventas'">
            <label>Histórico (días)</label>
            <select v-model.number="diasHistoricoProyeccion" class="select-input">
              <option :value="30">30 días</option>
              <option :value="60">60 días</option>
              <option :value="90">90 días</option>
              <option :value="180">180 días</option>
            </select>
          </div>

          <div class="filter-group" v-if="reporteSeleccionado === 'comparativo_mensual'">
            <label>Últimos meses</label>
            <select v-model.number="mesesComparativo" class="select-input">
              <option :value="3">3 meses</option>
              <option :value="6">6 meses</option>
              <option :value="12">12 meses</option>
              <option :value="24">24 meses</option>
            </select>
          </div>

        </div>

        <div class="filter-row dates">
          <div class="date-group">
            <template v-if="showDateFilters">
              <div class="date-buttons">
                <button @click="setHoy" class="date-btn">Hoy</button>
                <button @click="setSemana" class="date-btn">Última Semana</button>
                <button @click="setMes" class="date-btn">Último Mes</button>
              </div>

              <div class="date-inputs">
                <div class="date-field">
                  <label>Fecha Inicio</label>
                  <input
                    type="date"
                    v-model="filtros.fechaInicio"
                    @change="validarFechas"
                  />
                </div>
                <div class="date-field">
                  <label>Fecha Fin</label>
                  <input
                    type="date"
                    v-model="filtros.fechaFin"
                    @change="validarFechas"
                    :min="filtros.fechaInicio"
                  />
                </div>
              </div>
            </template>

            <button
              @click="openModalHeaderFooter"
              class="header-footer-btn"
            >
              Configurar Encabezado/Pie de página
            </button>

            <div class="button-group">
              <button
                @click="generarReporte('pdf')"
                class="btn pdf-btn"
                :disabled="!canExportReport"
              >
                PDF
              </button>
              <button
                @click="generarReporte('excel')"
                class="btn excel-btn"
                :disabled="!canExportReport"
              >
                EXCEL
              </button>
              <button
                @click="generarReporte('preview')"
                class="btn generate-btn"
                :disabled="!canGenerateReport"
              >
                {{ cargando ? "Generando..." : "Generar" }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección de control de logo -->
      <div class="controls-section">
        <div class="image-upload-wrapper">
          <div
            class="image-drop-area"
            :class="{ dragging: isDragging, 'has-image': logoUrl }"
            @dragenter.prevent="isDragging = true"
            @dragleave.prevent="onDragLeave"
            @dragover.prevent
            @drop.prevent="handleDrop"
          >
            <div v-if="isDragging" class="drag-overlay">
              <span>Suelta aquí</span>
            </div>

            <div v-else-if="!logoUrl" class="upload-content">
              <div class="upload-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="17 8 12 3 7 8"></polyline>
                  <line x1="12" y1="3" x2="12" y2="15"></line>
                </svg>
              </div>
              <h3>Arrastra y suelta una imagen</h3>
              <p class="separator">o</p>
              <button class="upload-button" @click="triggerFileInput">
                Sube una foto
              </button>
              <p class="upload-info">
                El archivo debe ser un JPEG, JPG, PNG o WebP de hasta 40 MB
              </p>
            </div>

            <div v-else class="preview-content">
              <img
                v-if="logoUrl"
                :src="logoUrl"
                alt="Logo preview"
                class="preview-image"
              />
              <div class="image-actions">
                <button class="remove-button" @click="removeImage">
                  Eliminar imagen
                </button>
                <button class="change-button" @click="triggerFileInput">
                  Cambiar imagen
                </button>
              </div>
            </div>
          </div>
          <input
            type="file"
            ref="fileInput"
            @change="handleFileChange"
            accept="image/jpeg,image/jpg,image/png,image/webp"
            class="hidden-input"
          />
        </div>
      </div>
    </div>

    <!-- Mensaje de error si existe -->
    <div v-if="error" class="error-message">
      <div class="alert-message error">
        <span class="alert-icon">!</span>
        {{ error }}
      </div>
    </div>

    <!-- Modal de Header/Footer -->
    <HeaderFooterDesigner
      v-model="showHeaderFooterModal"
      :config="headerFooterConfig"
      @save="handleHeaderFooterSave"
    />

    <!-- Checkbox de especificación para reportes detallados -->
    <div
      v-if="intentoGenerar && datosReporte.length > 0 && showSpecificationCheckbox"
      class="checkbox-container"
    >
      <label class="checkbox-label">
        <input
          type="checkbox"
          v-model="especificacion"
          class="checkbox-input"
        />
        <span class="checkbox-text">Mostrar Especificación Detallada</span>
      </label>
    </div>

    <!-- Renderizado dinámico de tablas según tipo de reporte -->
    <div v-if="intentoGenerar && datosReporte.length > 0">
      <!-- Reportes de ventas tradicionales -->
      <template v-if="isTraditionalSalesReport">
        <!-- Tabla única cuando no hay especificación -->
        <table
          v-if="!especificacion"
          class="table-no-spec"
        >
          <thead>
            <tr>
              <th>{{ labelFiltro }}</th>
              <th>Valor Exento</th>
              <th>Valor Gravado 15%</th>
              <th>Valor Gravado 18%</th>
              <th>ISV</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(grupo, grupIndex) in datosAgrupados"
              :key="grupIndex"
            >
              <tr class="group-header">
                <td><strong>{{ grupo.nombre }}</strong></td>
                <td>{{ formatearMoneda(grupo.valor_exento) }}</td>
                <td>{{ formatearMoneda(grupo.gravado_15) }}</td>
                <td>{{ formatearMoneda(grupo.gravado_18) }}</td>
                <td>{{ formatearMoneda(grupo.total_isv) }}</td>
                <td>{{ formatearMoneda(grupo.total) }}</td>
              </tr>
            </template>
          </tbody>
        </table>

        <!-- Tablas con especificación -->
        <template v-else>
          <div class="tablas-container">
            <table class="table-headers">
              <thead>
                <tr>
                  <th>{{ labelFiltro }}</th>
                  <th>Valor Exento</th>
                  <th>Valor Gravado 15%</th>
                  <th>Valor Gravado 18%</th>
                  <th>ISV</th>
                  <th>Total</th>
                </tr>
              </thead>
            </table>

            <template
              v-for="(grupo, grupIndex) in datosAgrupados"
              :key="grupIndex"
            >
              <table class="table-content">
                <tbody>
                  <tr class="group-header">
                    <td><strong>{{ grupo.nombre }}</strong></td>
                    <td>{{ formatearMoneda(grupo.valor_exento) }}</td>
                    <td>{{ formatearMoneda(grupo.gravado_15) }}</td>
                    <td>{{ formatearMoneda(grupo.gravado_18) }}</td>
                    <td>{{ formatearMoneda(grupo.total_isv) }}</td>
                    <td>{{ formatearMoneda(grupo.total) }}</td>
                  </tr>
                </tbody>
              </table>

              <!-- Tabla de desglose -->
              <table
                v-if="especificacion && grupo.desglose?.length"
                class="table-content desglose-table"
              >
                <thead class="desglose-header">
                  <tr>
                    <th colspan="6" class="desglose-title">
                      Facturas de {{ grupo.nombre }}
                    </th>
                  </tr>
                  <tr>
                    <th>Número de Factura</th>
                    <th>Valor Exento</th>
                    <th>Valor Gravado 15%</th>
                    <th>Valor Gravado 18%</th>
                    <th>ISV</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="factura in grupo.desglose"
                    :key="factura.id"
                    class="detail-row"
                  >
                    <td class="numero-factura">
                      {{ factura.nombre }}
                    </td>
                    <td>{{ formatearMoneda(factura.valor_exento) }}</td>
                    <td>{{ formatearMoneda(factura.gravado_15) }}</td>
                    <td>{{ formatearMoneda(factura.gravado_18) }}</td>
                    <td>{{ formatearMoneda(factura.total_isv) }}</td>
                    <td>{{ formatearMoneda(factura.total) }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </template>
      </template>

      <!-- ✅ REPORTE DE COMPRAS -->
      <template v-else-if="reporteSeleccionado === 'reporte_compras'">
        <div class="compras-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>No.</th>
                <th>Fecha</th>
                <th>Proveedor</th>
                <th>RTN</th>
                <th>CAI</th>
                <th># Factura</th>
                <th>Gravado 15%</th>
                <th>Exento</th>
                <th>Subtotal</th>
                <th>Descuento</th>
                <th>Impuesto 15%</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(compra, index) in datosReporte" :key="compra.id_compra">
                <td class="numero-row">{{ index + 1 }}</td>
                <td class="fecha-compra">{{ formatearFecha(compra.fecha) }}</td>
                <td class="proveedor-nombre">{{ compra.proveedor }}</td>
                <td class="rtn-proveedor">{{ compra.rtn }}</td>
                <td class="cai-factura">{{ compra.cai }}</td>
                <td class="numero-factura-compra">{{ compra.numero_factura }}</td>
                <td class="gravado">{{ formatearMoneda(compra.gravado_15) }}</td>
                <td class="exento">{{ formatearMoneda(compra.valor_exento) }}</td>
                <td class="subtotal">{{ formatearMoneda(compra.subtotal) }}</td>
                <td class="descuento">{{ formatearMoneda(compra.descuento) }}</td>
                <td class="impuesto">{{ formatearMoneda(compra.impuesto_15) }}</td>
                <td class="total-compra">{{ formatearMoneda(compra.total) }}</td>
              </tr>
            </tbody>
          </table>

          <div class="resumen-compras">
            <div class="resumen-titulo">Resumen Total de Compras</div>
            <div class="resumen-grid">
              <div class="resumen-item">
                <div class="resumen-label">Total Gravado 15%</div>
                <div class="resumen-valor">{{ formatearMoneda(totalesCompras.total_gravado_15) }}</div>
              </div>
              <div class="resumen-item">
                <div class="resumen-label">Total Exento</div>
                <div class="resumen-valor">{{ formatearMoneda(totalesCompras.total_exento) }}</div>
              </div>
              <div class="resumen-item">
                <div class="resumen-label">Total Subtotal</div>
                <div class="resumen-valor">{{ formatearMoneda(totalesCompras.total_subtotal) }}</div>
              </div>
              <div class="resumen-item">
                <div class="resumen-label">Total Descuentos</div>
                <div class="resumen-valor">{{ formatearMoneda(totalesCompras.total_descuento) }}</div>
              </div>
              <div class="resumen-item">
                <div class="resumen-label">Total Impuesto 15%</div>
                <div class="resumen-valor">{{ formatearMoneda(totalesCompras.total_impuesto_15) }}</div>
              </div>
              <div class="resumen-item total-general">
                <div class="resumen-label">TOTAL GENERAL</div>
                <div class="resumen-valor">{{ formatearMoneda(totalesCompras.total_general) }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- ✅ REPORTE DE PRODUCTOS MÁS VENDIDOS -->
      <template v-else-if="reporteSeleccionado === 'productos_vendidos'">
        <div class="productos-vendidos-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Producto</th>
                <th>Código</th>
                <th>Cantidad Vendida</th>
                <th>Total Vendido</th>
                <th>Número de Ventas</th>
                <th>Precio Unitario</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(producto, index) in datosReporte" :key="producto.id_producto">
                <td class="rank">{{ index + 1 }}</td>
                <td>{{ producto.nombre }}</td>
                <td>{{ producto.codigo }}</td>
                <td class="cantidad">{{ formatearCantidad(producto.cantidad_vendida) }}</td>
                <td class="monto">{{ formatearMoneda(producto.total_vendido) }}</td>
                <td class="numero">{{ producto.numero_ventas }}</td>
                <td class="precio">{{ formatearMoneda(producto.precio_unitario) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- ✅ REPORTE DE CLIENTES FRECUENTES -->
      <template v-else-if="reporteSeleccionado === 'clientes_frecuentes'">
        <div class="clientes-frecuentes-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Cliente</th>
                <th>Teléfono</th>
                <th>Correo</th>
                <th>Número de Visitas</th>
                <th>Monto Total</th>
                <th>Promedio por Compra</th>
                <th>Última Visita</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cliente, index) in datosReporte" :key="cliente.id_cliente">
                <td class="rank">{{ index + 1 }}</td>
                <td>{{ cliente.nombre }}</td>
                <td>{{ cliente.telefono || 'N/A' }}</td>
                <td>{{ cliente.correo || 'N/A' }}</td>
                <td class="visits">{{ cliente.numero_visitas }}</td>
                <td class="amount">{{ formatearMoneda(cliente.monto_total) }}</td>
                <td class="average">{{ formatearMoneda(cliente.promedio_compra) }}</td>
                <td class="date">{{ formatearFecha(cliente.ultima_visita) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- ✅ REPORTE DE VENTAS POR HORA -->
      <template v-else-if="reporteSeleccionado === 'ventas_por_hora'">
        <div class="ventas-hora-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Hora</th>
                <th>Cantidad de Ventas</th>
                <th>Total Vendido</th>
                <th>Promedio por Venta</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="hora in datosReporte" :key="hora.hora">
                <td class="hora">{{ hora.hora_formato }}</td>
                <td class="numero">{{ hora.cantidad_ventas }}</td>
                <td class="total">{{ formatearMoneda(hora.total_ventas) }}</td>
                <td class="promedio">{{ formatearMoneda(hora.promedio_venta) }}</td>
              </tr>
            </tbody>
          </table>

          <div class="chart-container">
            <canvas ref="horasChart"></canvas>
          </div>
        </div>
      </template>

      <!-- ✅ REPORTE DE MÉTODOS DE PAGO -->
      <template v-else-if="reporteSeleccionado === 'metodos_pago'">
        <div class="metodos-pago-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Método de Pago</th>
                <th>Cantidad de Transacciones</th>
                <th>Monto Total</th>
                <th>Porcentaje</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="metodo in datosReporte" :key="metodo.metodo_pago">
                <td class="metodo">{{ metodo.metodo_pago }}</td>
                <td class="transacciones">{{ metodo.cantidad_transacciones }}</td>
                <td class="monto">{{ formatearMoneda(metodo.total_monto) }}</td>
                <td>
                  <div class="percentage-bar">
                    <div class="bar" :style="{ width: metodo.porcentaje + '%' }"></div>
                    <span>{{ metodo.porcentaje }}%</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="chart-container">
            <canvas ref="metodosChart"></canvas>
          </div>
        </div>
      </template>

      <!-- ✅ REPORTE DE VENTAS CANCELADAS -->
      <template v-else-if="reporteSeleccionado === 'ventas_canceladas'">
        <div class="ventas-canceladas-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Factura</th>
                <th>Empleado</th>
                <th>Cliente</th>
                <th>Sucursal</th>
                <th>Total</th>
                <th>Fecha</th>
                <th>Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="venta in datosReporte" :key="venta.id_venta">
                <td class="numero-factura">{{ venta.numero_factura }}</td>
                <td>{{ venta.empleado }}</td>
                <td>{{ venta.cliente }}</td>
                <td>{{ venta.sucursal }}</td>
                <td class="monto-cancelado">{{ formatearMoneda(venta.total) }}</td>
                <td class="fecha-compra">{{ formatearFecha(venta.fecha_anulacion) }}</td>
                <td>{{ venta.motivo_cancelacion || 'N/A' }}</td>
              </tr>
            </tbody>
          </table>

          <div class="ventas-canceladas-summary">
            <div class="summary-item">
              <span class="summary-label">Total de Ventas Canceladas:</span>
              <span class="summary-value">{{ totalesVentasCanceladas.total_ventas }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Monto Total Cancelado:</span>
              <span class="summary-value monto-cancelado">{{ formatearMoneda(totalesVentasCanceladas.total_monto) }}</span>
            </div>
          </div>

          <div class="desglose-canceladas">
            <h4>Desglose de Montos Cancelados</h4>
            <div class="desglose-grid">
              <div class="desglose-item">
                <span class="desglose-label">Exento:</span>
                <span class="desglose-valor">{{ formatearMoneda(totalesVentasCanceladas.total_extento) }}</span>
              </div>
              <div class="desglose-item">
                <span class="desglose-label">Gravado 15%:</span>
                <span class="desglose-valor">{{ formatearMoneda(totalesVentasCanceladas.gravado_15) }}</span>
              </div>
              <div class="desglose-item">
                <span class="desglose-label">Gravado 18%:</span>
                <span class="desglose-valor">{{ formatearMoneda(totalesVentasCanceladas.gravado_18) }}</span>
              </div>
              <div class="desglose-item">
                <span class="desglose-label">ISV:</span>
                <span class="desglose-valor">{{ formatearMoneda(totalesVentasCanceladas.total_isv) }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- REPORTE DE ANULACIONES -->
      <template v-else-if="reporteSeleccionado === 'anulaciones'">
        <div class="ventas-canceladas-container">
          <div class="ventas-canceladas-summary" style="margin-bottom:16px">
            <div class="summary-item">
              <span class="summary-label">Total anulaciones:</span>
              <span class="summary-value">{{ datosReporte.length }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Monto total:</span>
              <span class="summary-value monto-cancelado">{{ formatearMoneda(datosReporte.reduce((s,f)=>s+Number(f.facturas?.[0]?.total||0),0)) }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Reembolsos efectivo:</span>
              <span class="summary-value">{{ datosReporte.filter(f=>f.facturas?.[0]?.tipo_factura==='Efectivo').length }}</span>
            </div>
          </div>
          <table class="modern-table">
            <thead>
              <tr>
                <th>Factura</th>
                <th>Monto</th>
                <th>Tipo pago</th>
                <th>Cajero</th>
                <th>Cancelado por</th>
                <th>Motivo</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="f in datosReporte" :key="f.id_venta">
                <td class="numero-factura">{{ f.facturas?.[0]?.codigo_factura || '—' }}</td>
                <td class="monto-cancelado">{{ formatearMoneda(f.facturas?.[0]?.total || 0) }}</td>
                <td>{{ f.facturas?.[0]?.tipo_factura || '—' }}</td>
                <td>{{ f.Usuarios ? (f.Usuarios.nombre + ' ' + f.Usuarios.apellido) : '—' }}</td>
                <td>{{ f.cancelado_por || '—' }}</td>
                <td>{{ f.descripcion || '—' }}</td>
                <td class="fecha-compra">{{ formatearFecha(f.cancelado_at || f.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- REPORTE DE DEVOLUCIONES / NOTAS DE CRÉDITO -->
      <template v-else-if="reporteSeleccionado === 'devoluciones'">
        <div class="ventas-canceladas-container">
          <div class="ventas-canceladas-summary" style="margin-bottom:16px">
            <div class="summary-item">
              <span class="summary-label">Total NCs:</span>
              <span class="summary-value">{{ datosReporte.length }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Monto total devuelto:</span>
              <span class="summary-value monto-cancelado">{{ formatearMoneda(datosReporte.reduce((s,r)=>s+Number(r.monto_devuelto||0),0)) }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Aplicadas:</span>
              <span class="summary-value">{{ datosReporte.filter(r=>r.aplicada).length }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Pendientes:</span>
              <span class="summary-value">{{ datosReporte.filter(r=>!r.aplicada).length }}</span>
            </div>
          </div>
          <table class="modern-table">
            <thead>
              <tr>
                <th>Número NC</th>
                <th>Factura original</th>
                <th>Monto</th>
                <th>Motivo</th>
                <th>Productos</th>
                <th>Generado por</th>
                <th>Estado</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="d in datosReporte" :key="d.id_devolucion">
                <td class="numero-factura">{{ d.numero_nota_credito || '—' }}</td>
                <td>{{ d.Ventas?.facturas?.[0]?.codigo_factura || '—' }}</td>
                <td class="monto-cancelado">{{ formatearMoneda(d.monto_devuelto) }}</td>
                <td>{{ d.motivo || '—' }}</td>
                <td style="font-size:12px;color:#666">
                  {{ (d.detalle_devoluciones||[]).map(x=>`${x.producto?.nombre||'Item'} ×${x.cantidad_devuelta}`).join(', ') || '—' }}
                </td>
                <td>{{ d.Usuarios ? (d.Usuarios.nombre + ' ' + d.Usuarios.apellido) : '—' }}</td>
                <td>
                  <span :style="{ color: d.aplicada ? '#0a6640' : '#856404', fontWeight: 600, fontSize: '12px' }">
                    {{ d.aplicada ? 'Aplicada' : 'Pendiente' }}
                  </span>
                </td>
                <td class="fecha-compra">{{ formatearFecha(d.created_at) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- ✅ REPORTE DE FACTURAS SIN SAR -->
<template v-else-if="reporteSeleccionado === 'facturas_sin_sar'">
  <div class="facturas-sin-sar-container">
    <div class="alert-warning-sar">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <strong>Atención:</strong> Estas facturas fueron generadas con numeración temporal cuando el rango SAR estaba vencido. 
      <strong>Deben ser refacturadas</strong> una vez se active un nuevo rango SAR válido.
    </div>

    <table class="modern-table">
      <thead>
        <tr>
          <th>Número Temporal</th>
          <th>Fecha</th>
          <th>Estado</th>
          <th>Empleado</th>
          <th>Cliente</th>
          <th>Sucursal</th>
          <th>Exento</th>
          <th>Gravado 15%</th>
          <th>Gravado 18%</th>
          <th>ISV</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="factura in datosReporte" :key="factura.id_factura">
          <td class="numero-temporal">
            <i class="bi bi-exclamation-circle text-warning"></i>
            {{ factura.numero_temporal }}
          </td>
          <td class="fecha-factura">{{ formatearFecha(factura.fecha) }}</td>
          <td>
            <span class="badge-estado" :class="'badge-' + factura.estado.toLowerCase()">
              {{ factura.estado }}
            </span>
          </td>
          <td>{{ factura.empleado }}</td>
          <td>{{ factura.cliente }}</td>
          <td>{{ factura.sucursal }}</td>
          <td class="monto">{{ formatearMoneda(factura.total_extento) }}</td>
          <td class="monto">{{ formatearMoneda(factura.gravado_15) }}</td>
          <td class="monto">{{ formatearMoneda(factura.gravado_18) }}</td>
          <td class="monto-isv">{{ formatearMoneda(factura.total_isv) }}</td>
          <td class="monto-total">{{ formatearMoneda(factura.total) }}</td>
        </tr>
      </tbody>
    </table>

    <div class="resumen-sin-sar">
      <div class="resumen-titulo">
        <i class="bi bi-exclamation-diamond-fill"></i>
        Resumen de Facturas Sin SAR
      </div>
      <div class="resumen-grid">
        <div class="resumen-item">
          <div class="resumen-label">Total de Facturas</div>
          <div class="resumen-valor-sar">{{ totalesFacturasSinSAR.total_facturas }}</div>
        </div>
        <div class="resumen-item">
          <div class="resumen-label">Total Exento</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFacturasSinSAR.total_extento) }}</div>
        </div>
        <div class="resumen-item">
          <div class="resumen-label">Total Gravado 15%</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFacturasSinSAR.total_gravado_15) }}</div>
        </div>
        <div class="resumen-item">
          <div class="resumen-label">Total Gravado 18%</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFacturasSinSAR.total_gravado_18) }}</div>
        </div>
        <div class="resumen-item">
          <div class="resumen-label">Total ISV</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFacturasSinSAR.total_isv) }}</div>
        </div>
        <div class="resumen-item total-general-sar">
          <div class="resumen-label">TOTAL GENERAL</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFacturasSinSAR.total_general) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

      <!-- ✅ REPORTE FISCAL DE VENTAS -->
<template v-else-if="reporteSeleccionado === 'reporte_fiscal'">
  <div class="fiscal-container">
    <table class="modern-table fiscal-table">
      <thead>
        <tr class="fiscal-main-header">
          <th rowspan="2">Fecha</th>
          <th colspan="2"># de Factura</th>
          <th colspan="5">Ventas</th>
          <th rowspan="2">Total</th>
        </tr>
        <tr class="fiscal-sub-header">
          <th>Desde</th>
          <th>Hasta</th>
          <th>Exentas</th>
          <th>Gravadas 15%</th>
          <th>Impuesto 15%</th>
          <th>Gravadas 18%</th>
          <th>Impuesto 18%</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(dia, index) in datosReporte" :key="index">
          <td class="fecha-fiscal">{{ formatearFecha(dia.fecha) }}</td>
          <td class="factura-desde">{{ dia.factura_desde }}</td>
          <td class="factura-hasta">{{ dia.factura_hasta }}</td>
          <td class="exentas">{{ formatearMoneda(dia.exentas) }}</td>
          <td class="gravadas">{{ formatearMoneda(dia.gravadas_15) }}</td>
          <td class="impuesto">{{ formatearMoneda(dia.impuesto_15) }}</td>
          <td class="gravadas">{{ formatearMoneda(dia.gravadas_18) }}</td>
          <td class="impuesto">{{ formatearMoneda(dia.impuesto_18) }}</td>
          <td class="total-fiscal">{{ formatearMoneda(dia.total) }}</td>
        </tr>
      </tbody>
    </table>

    <div class="resumen-fiscal">
      <div class="resumen-titulo">Resumen del Período</div>
      <div class="resumen-grid-fiscal">
        <div class="resumen-item">
          <div class="resumen-label">Total Exentas</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFiscales.total_exentas) }}</div>
        </div>
        <div class="resumen-item">
          <div class="resumen-label">Total Gravadas 15%</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFiscales.total_gravadas_15) }}</div>
        </div>
        <div class="resumen-item">
          <div class="resumen-label">Total Impuesto 15%</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFiscales.total_impuesto_15) }}</div>
        </div>
        <div class="resumen-item">
          <div class="resumen-label">Total Gravadas 18%</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFiscales.total_gravadas_18) }}</div>
        </div>
        <div class="resumen-item">
          <div class="resumen-label">Total Impuesto 18%</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFiscales.total_impuesto_18) }}</div>
        </div>
        <div class="resumen-item total-general">
          <div class="resumen-label">TOTAL GENERAL</div>
          <div class="resumen-valor">{{ formatearMoneda(totalesFiscales.total_general) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>


      <!-- ✅ UTILIDAD BRUTA -->
      <template v-else-if="reporteSeleccionado === 'utilidad_bruta'">
        <div v-if="datosAmpliados" class="amp-summary-totales">
          <div class="amp-card-tot"><span>Total Ventas</span><strong>L. {{ fmtNum(datosAmpliados.totales?.total_ventas) }}</strong></div>
          <div class="amp-card-tot"><span>Total Costo</span><strong>L. {{ fmtNum(datosAmpliados.totales?.total_costo) }}</strong></div>
          <div class="amp-card-tot amp-highlight"><span>Utilidad Bruta</span><strong>L. {{ fmtNum(datosAmpliados.totales?.utilidad_bruta) }}</strong></div>
          <div class="amp-card-tot" :class="margenClassAmp"><span>Margen Promedio</span><strong>{{ fmtNum(datosAmpliados.totales?.margen_promedio) }}%</strong></div>
        </div>
        <div class="table-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Uds. Vendidas</th>
                <th>Precio Prom.</th>
                <th>Costo Prom.</th>
                <th>Total Ventas</th>
                <th>Total Costo</th>
                <th>Utilidad</th>
                <th>Margen %</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(f, i) in datosReporte" :key="i">
                <td>{{ f.producto }}</td>
                <td class="numero">{{ f.unidades_vendidas }}</td>
                <td class="monto">L. {{ fmtNum(f.precio_promedio) }}</td>
                <td class="monto">L. {{ fmtNum(f.costo_promedio) }}</td>
                <td class="monto">L. {{ fmtNum(f.total_ventas) }}</td>
                <td class="monto">L. {{ fmtNum(f.total_costo) }}</td>
                <td class="monto"><strong>L. {{ fmtNum(f.utilidad) }}</strong></td>
                <td class="monto">
                  <span :class="f.margen >= 20 ? 'badge-amp-success' : f.margen >= 10 ? 'badge-amp-warning' : 'badge-amp-danger'">
                    {{ fmtNum(f.margen) }}%
                  </span>
                </td>
              </tr>
            </tbody>
            <tfoot v-if="datosAmpliados">
              <tr class="amp-fila-total">
                <td><strong>TOTALES</strong></td>
                <td class="numero"><strong>{{ datosAmpliados.totales?.total_unidades }}</strong></td>
                <td colspan="2"></td>
                <td class="monto"><strong>L. {{ fmtNum(datosAmpliados.totales?.total_ventas) }}</strong></td>
                <td class="monto"><strong>L. {{ fmtNum(datosAmpliados.totales?.total_costo) }}</strong></td>
                <td class="monto"><strong>L. {{ fmtNum(datosAmpliados.totales?.utilidad_bruta) }}</strong></td>
                <td class="monto"><strong>{{ fmtNum(datosAmpliados.totales?.margen_promedio) }}%</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </template>

      <!-- ✅ ROTACIÓN DE INVENTARIO -->
      <template v-else-if="reporteSeleccionado === 'rotacion_inventario'">
        <div class="amp-info-box">
          <i class="bi bi-info-circle"></i>
          Productos que llevan más de <strong>{{ diasRotacion }} días</strong> sin registrar ventas.
          Total: <strong>{{ datosReporte.length }} productos</strong>
        </div>
        <div class="table-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Categoría</th>
                <th>Stock Actual</th>
                <th>Precio Venta</th>
                <th>Valor Inventario</th>
                <th>Última Venta</th>
                <th>Días Sin Ventas</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(f, i) in datosReporte" :key="i" :class="{ 'row-alerta': f.dias_sin_ventas > 90 }">
                <td>{{ f.producto }}</td>
                <td>{{ f.categoria }}</td>
                <td class="numero">{{ f.stock_actual }}</td>
                <td class="monto">L. {{ fmtNum(f.precio_venta) }}</td>
                <td class="monto">L. {{ fmtNum(f.valor_inventario) }}</td>
                <td>{{ f.ultima_venta || 'Sin ventas' }}</td>
                <td class="numero">
                  <span :class="f.dias_sin_ventas > 90 ? 'badge-amp-danger' : f.dias_sin_ventas > 60 ? 'badge-amp-warning' : 'badge-amp-info'">
                    {{ f.dias_sin_ventas > 999 ? '999+' : f.dias_sin_ventas }} días
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- ✅ COMPARATIVO MENSUAL -->
      <template v-else-if="reporteSeleccionado === 'comparativo_mensual'">
        <div v-if="datosAmpliados?.meses?.length" class="amp-comparativo-grid">
          <div v-for="(mes, i) in datosAmpliados.meses" :key="i" class="amp-mes-card">
            <div class="amp-mes-nombre">{{ mes.mes_nombre }}</div>
            <div class="amp-mes-stat"><span>Ventas</span><strong>L. {{ fmtNum(mes.total_ventas) }}</strong></div>
            <div class="amp-mes-stat"><span>Transacciones</span><strong>{{ mes.total_transacciones }}</strong></div>
            <div class="amp-mes-stat"><span>Prom. Venta</span><strong>L. {{ fmtNum(mes.ticket_promedio) }}</strong></div>
            <div class="amp-mes-bar-wrap">
              <div class="amp-mes-bar" :style="{ width: ampBarWidth(mes.total_ventas) + '%' }"></div>
            </div>
          </div>
        </div>
        <div class="table-container" style="margin-top:16px">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Mes</th>
                <th>Total Ventas</th>
                <th>Transacciones</th>
                <th>Promedio por Venta</th>
                <th>Variación</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(mes, i) in datosReporte" :key="i">
                <td>{{ mes.mes_nombre }}</td>
                <td class="monto">L. {{ fmtNum(mes.total_ventas) }}</td>
                <td class="numero">{{ mes.total_transacciones }}</td>
                <td class="monto">L. {{ fmtNum(mes.ticket_promedio) }}</td>
                <td class="monto">
                  <span v-if="i === 0" class="badge-amp-info">Base</span>
                  <span v-else :class="ampVariacion(mes, datosReporte[i-1]) >= 0 ? 'badge-amp-success' : 'badge-amp-danger'">
                    {{ ampVariacion(mes, datosReporte[i-1]) >= 0 ? '+' : '' }}{{ fmtNum(ampVariacion(mes, datosReporte[i-1])) }}%
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- ✅ ÓRDENES DE PRODUCCIÓN -->
      <template v-else-if="reporteSeleccionado === 'ordenes_produccion'">
        <div class="amp-summary-totales" style="margin-bottom:16px">
          <div class="amp-card-tot"><span>Total Órdenes</span><strong>{{ totalesProduccion.total_ordenes }}</strong></div>
          <div class="amp-card-tot amp-highlight"><span>Completadas</span><strong>{{ totalesProduccion.total_completadas }}</strong></div>
          <div class="amp-card-tot"><span>Unidades Producidas</span><strong>{{ fmtNum(totalesProduccion.total_unidades) }}</strong></div>
          <div class="amp-card-tot amp-highlight"><span>Costo Total (completadas)</span><strong>L. {{ fmtNum(totalesProduccion.costo_total) }}</strong></div>
        </div>
        <div class="table-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Fecha</th>
                <th>Receta</th>
                <th>Producto</th>
                <th>Cantidad</th>
                <th>Estado</th>
                <th>Costo Total</th>
                <th>Costo/Ud</th>
                <th>Precio Actual</th>
                <th>Margen %</th>
                <th>Usuario</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(o, i) in datosReporte" :key="o.id_orden">
                <td class="rank">{{ i + 1 }}</td>
                <td class="fecha-compra">{{ formatearFecha(o.fecha) }}</td>
                <td>{{ o.receta }}</td>
                <td>{{ o.producto }}</td>
                <td class="numero">{{ o.cantidad }}</td>
                <td>
                  <span :style="{
                    color: o.estado === 'completada' ? '#16a34a' : o.estado === 'cancelada' ? '#dc2626' : '#ca8a04',
                    fontWeight: 600, fontSize: '12px'
                  }">{{ o.estado }}</span>
                </td>
                <td class="monto">L. {{ fmtNum(o.costo_total) }}</td>
                <td class="monto">L. {{ fmtNum(o.costo_por_unidad) }}</td>
                <td class="monto">L. {{ fmtNum(o.precio_actual) }}</td>
                <td class="monto">
                  <span :class="o.margen_pct >= 20 ? 'badge-amp-success' : o.margen_pct >= 10 ? 'badge-amp-warning' : 'badge-amp-danger'">
                    {{ o.margen_pct }}%
                  </span>
                </td>
                <td style="font-size:12px">{{ o.usuario }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- ✅ RENDIMIENTO POR RECETA -->
      <template v-else-if="reporteSeleccionado === 'margen_produccion'">
        <div class="amp-summary-totales" style="margin-bottom:16px">
          <div class="amp-card-tot"><span>Recetas Activas</span><strong>{{ datosReporte.length }}</strong></div>
          <div class="amp-card-tot"><span>Órdenes Completadas</span><strong>{{ totalesProduccion.total_ordenes }}</strong></div>
          <div class="amp-card-tot"><span>Unidades Producidas</span><strong>{{ fmtNum(totalesProduccion.total_unidades) }}</strong></div>
          <div class="amp-card-tot amp-highlight"><span>Costo Total</span><strong>L. {{ fmtNum(totalesProduccion.costo_total) }}</strong></div>
        </div>
        <div class="table-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Receta</th>
                <th>Producto</th>
                <th>Órdenes</th>
                <th>Uds. Producidas</th>
                <th>Costo Total</th>
                <th>Costo/Unidad</th>
                <th>Precio Actual</th>
                <th>Margen %</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in datosReporte" :key="i">
                <td>{{ r.receta }}</td>
                <td>{{ r.producto }}</td>
                <td class="numero">{{ r.ordenes }}</td>
                <td class="numero">{{ fmtNum(r.total_unidades) }}</td>
                <td class="monto">L. {{ fmtNum(r.costo_total) }}</td>
                <td class="monto">L. {{ fmtNum(r.costo_por_unidad) }}</td>
                <td class="monto">L. {{ fmtNum(r.precio_actual) }}</td>
                <td class="monto">
                  <span :class="r.margen_pct >= 20 ? 'badge-amp-success' : r.margen_pct >= 10 ? 'badge-amp-warning' : 'badge-amp-danger'">
                    {{ r.margen_pct }}%
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <!-- ✅ PROYECCIÓN DE VENTAS -->
      <template v-else-if="reporteSeleccionado === 'proyeccion_ventas'">
        <div v-if="proyeccionData" class="amp-summary-totales" style="margin-bottom:16px">
          <div class="amp-card-tot"><span>Total Período</span><strong>L. {{ fmtNum(proyeccionData.total_periodo) }}</strong></div>
          <div class="amp-card-tot"><span>Promedio Diario</span><strong>L. {{ fmtNum(proyeccionData.promedio_diario) }}</strong></div>
          <div class="amp-card-tot amp-highlight"><span>Proyectado (base 7d)</span><strong>L. {{ fmtNum(proyeccionData.promedio_base) }}/día</strong></div>
          <div class="amp-card-tot amp-highlight"><span>Proyectado 30d</span><strong>L. {{ fmtNum((proyeccionData.promedio_base || 0) * 30) }}</strong></div>
        </div>
        <div v-if="proyeccionData" class="table-container">
          <table class="modern-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Total Real</th>
                <th>Promedio Móvil 7d</th>
                <th>Proyectado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in [...(proyeccionData.historico || []).slice(-30), ...(proyeccionData.proyeccion || [])]" :key="i"
                  :class="row.tipo === 'Proyectado' || row.proyectado != null ? 'fila-proyectada' : ''">
                <td>{{ row.fecha }}</td>
                <td><span :class="row.proyectado != null ? 'badge-amp-info' : 'badge-amp-success'">{{ row.proyectado != null ? 'Proyectado' : 'Real' }}</span></td>
                <td class="monto">{{ row.total != null ? 'L. ' + fmtNum(row.total) : '—' }}</td>
                <td class="monto">{{ row.ma7 != null ? 'L. ' + fmtNum(row.ma7) : '—' }}</td>
                <td class="monto">{{ row.proyectado != null ? 'L. ' + fmtNum(row.proyectado) : '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

    </div>

    <!-- Mensaje cuando no hay datos -->
    <div
      v-if="!cargando && intentoGenerar && fechasValidas && !datosReporte.length"
      class="no-data-message"
    >
      <div class="alert-message">
        <span class="alert-icon">i</span>
        No se encontraron datos para los criterios seleccionados
      </div>
    </div>
  </div>

  <!-- Sección de Resumen de Totales -->
  <div v-if="datosReporte.length > 0 && intentoGenerar && showTotalsSummary" class="resumen-totales">
    <div class="resumen-titulo">Resumen del Reporte</div>
    <div class="resumen-grid">
      <div class="resumen-item" v-if="totales.exento !== undefined">
        <div class="resumen-label">Total Exento</div>
        <div class="resumen-valor">{{ formatearMoneda(totales.exento) }}</div>
      </div>
      <div class="resumen-item" v-if="totales.gravado_15 !== undefined">
        <div class="resumen-label">Total Gravado 15%</div>
        <div class="resumen-valor">{{ formatearMoneda(totales.gravado_15) }}</div>
      </div>
      <div class="resumen-item" v-if="totales.gravado_18 !== undefined">
        <div class="resumen-label">Total Gravado 18%</div>
        <div class="resumen-valor">{{ formatearMoneda(totales.gravado_18) }}</div>
      </div>
      <div class="resumen-item" v-if="totales.total_isv !== undefined">
        <div class="resumen-label">Total ISV</div>
        <div class="resumen-valor">{{ formatearMoneda(totales.total_isv) }}</div>
      </div>
      <div class="resumen-item" v-if="totales.total !== undefined">
        <div class="resumen-label">Total General</div>
        <div class="resumen-valor">{{ formatearMoneda(totales.total) }}</div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
import { notis } from "../../services/notificaciones.js";
import HeaderFooterDesigner from "@/components/HeaderFooterDesigner.vue";
import ModalLoading from "@/components/ModalLoading.vue";
import solicitudes from "../../services/solicitudes.js";
import { setPageTitle } from "@/components/pageMetadata";
const { getSocket } = require('@/services/socket');

const {
  clientesReportes,
  sucursalReportes,
  reportesProductos,
  reportesEmpleados,
  getRegistrosEmpleados,
  getRegistrosClientes,
  getRegistrosSucursales,
  getRegistrosEmpleadosDesglose,
  getRegistrosClienteDesglose,
  getRegistrosSucursalDesglose,
  getDatosInstitucion,
  getProductosMasVendidos,
  getClientesFrecuentes,
  getInventarioBajoStock,
  getVentasPorHora,
  getReporteMetodosPago,
  getVentasCanceladas,
} = require("../../services/reporteSolicitudes.js");

const { esCeo } = require("../../services/usuariosSolicitudes");
import { getUtilidadBruta, getRotacionInventario, getComparativoMensual, getProyeccionVentas } from "../../services/featuresSolicitudes.js";
import { getOrdenes as getOrdenesProduccion } from "../../services/produccionSolicitudes.js";
import AdminVentas from "../../services/Soliadminventa.js";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "ReporteVentasAvanzado",
  components: {
    HeaderFooterDesigner,
    ModalLoading,
  },
  data() {
    return {
      titulo: "Reportería Avanzada",
      intentoGenerar: false,
      isLoading: false,
      id_usuario: "",
      sucursalAsignada: null,
      cargando: false,
      esCeo: false,
      error: null,
      isDragging: false,
      especificacion: false,
      logoUrl: null,
      reporteSeleccionado: "ventas_cliente",
      showHeaderFooterModal: false,
      datosBussines: [],
      charts: {
        horas: null,
        metodos: null
      },
      valorFiltroTexto: "",
      totalesVentasCanceladas: {
        total_ventas: 0,
        total_monto: 0,
        total_extento: 0,
        gravado_15: 0,
        gravado_18: 0,
        total_isv: 0,
      },
      totalesCompras: {
        total_gravado_15: 0,
        total_exento: 0,
        total_subtotal: 0,
        total_descuento: 0,
        total_impuesto_15: 0,
        total_general: 0
      },
     totalesFiscales: {
  total_exentas: 0,
  total_gravadas_15: 0,
  total_gravadas_18: 0,  // ✅ NUEVO
  total_impuesto_15: 0,
  total_impuesto_18: 0,  // ✅ NUEVO
  total_general: 0
},
totalesFacturasSinSAR: {
      total_facturas: 0,
      total_extento: 0,
      total_gravado_15: 0,
      total_gravado_18: 0,
      total_isv: 0,
      total_general: 0
    },
      totalesProduccion: {
        total_ordenes: 0,
        total_completadas: 0,
        total_unidades: 0,
        costo_total: 0,
      },
      diasRotacion: 30,
      mesesComparativo: 6,
      diasHistoricoProyeccion: 90,
      datosAmpliados: null,
      proyeccionData: null,
      filtros: {
        fechaInicio: "",
        fechaFin: "",
        valorFiltro: "",
        limite: "50",
        tipoPeriodo: "diario"
      },
      headerFooterConfig: {
        header: {
          enabled: true,
          text: "Reporte de Ventas",
          companyName: "",
          address: "",
          phone: "",
          email: "",
          showDivider: false,
        },
        footer: {
          enabled: true,
          template: "basic",
          customText: "Generado el {FECHA}",
          alignment: "center",
          showDivider: false,
        },
      },
      clientes: [],
      sucursales: [],
      empleados: [],
      productos: [],
      datosReporte: [],
      datosAgrupados: [],
      totales: {
        exento: 0,
        gravado_15: 0,
        gravado_18: 0,
        total_isv: 0,
        total: 0,
      },
    };
  },

  computed: {
    showEntityFilter() {
      if (this.reporteSeleccionado === 'ventas_sucursal' && !this.esCeo) {
        return false;
      }
      
      // ✅ Si es CEO, SIEMPRE mostrar filtro de sucursal
      if (this.esCeo) {
        const reportesConFiltroPropio = ['ventas_cliente', 'ventas_sucursal', 'ventas_empleado'];
        if (reportesConFiltroPropio.includes(this.reporteSeleccionado)) {
          return true;
        }
        return true; // Para todos los demás reportes también mostrar filtro
      }
      
      return ['ventas_cliente', 'ventas_sucursal', 'ventas_empleado'].includes(this.reporteSeleccionado);
    },

    showAdvancedFilters() {
      return !['inventario_bajo', 'rotacion_inventario', 'comparativo_mensual', 'proyeccion_ventas'].includes(this.reporteSeleccionado);
    },

    showDateFilters() {
      return !['inventario_bajo', 'rotacion_inventario', 'comparativo_mensual', 'proyeccion_ventas'].includes(this.reporteSeleccionado);
    },

    showSpecificationCheckbox() {
      return ['ventas_cliente', 'ventas_sucursal', 'ventas_empleado'].includes(this.reporteSeleccionado);
    },

    isTraditionalSalesReport() {
      return ['ventas_cliente', 'ventas_sucursal', 'ventas_empleado'].includes(this.reporteSeleccionado);
    },

    showTotalsSummary() {
      return this.isTraditionalSalesReport;
    },

    defaultSelectText() {
      if (
        this.reporteSeleccionado === "ventas_sucursal" &&
        !this.esCeo &&
        this.sucursales.length === 1
      ) {
        return "Escoge una opción";
      }
      return "Todos";
    },

    canExportReport() {
      return this.datosReporte.length > 0 && !this.cargando && this.intentoGenerar;
    },

    canGenerateReport() {
      if (['inventario_bajo', 'rotacion_inventario', 'comparativo_mensual', 'proyeccion_ventas'].includes(this.reporteSeleccionado)) {
        return !this.cargando;
      }
      return this.fechasValidas && !this.cargando;
    },

    margenClassAmp() {
      const m = this.datosAmpliados?.totales?.margen_promedio || 0;
      if (m >= 20) return 'amp-card-tot amp-highlight-green';
      if (m >= 10) return 'amp-card-tot amp-highlight-yellow';
      return 'amp-card-tot amp-highlight-red';
    },

    fechasValidas() {
      if (['inventario_bajo', 'rotacion_inventario', 'comparativo_mensual', 'proyeccion_ventas'].includes(this.reporteSeleccionado)) return true;

      return (
        this.filtros.fechaInicio &&
        this.filtros.fechaFin &&
        new Date(this.filtros.fechaFin) >= new Date(this.filtros.fechaInicio)
      );
    },

    opcionesFiltro() {
      switch (this.reporteSeleccionado) {
        case "ventas_cliente":
          return this.clientes || [];
        case "ventas_sucursal":
          return this.sucursales || [];
        case "ventas_empleado":
          return this.empleados || [];
        // ✅ NUEVO: Para CEO en otros reportes, retornar sucursales
        default:
          return this.esCeo ? (this.sucursales || []) : [];
      }
    },

    labelFiltro() {
      switch (this.reporteSeleccionado) {
        case "ventas_cliente":
          return "Cliente";
        case "ventas_sucursal":
          return this.esCeo ? "Sucursal" : "Cliente";
        case "ventas_empleado":
          return "Empleado";
        // ✅ NUEVO: Para CEO en otros reportes, mostrar "Sucursal"
        default:
          return this.esCeo ? "Sucursal" : "";
      }
    },

    valorFiltro: {
      get() {
        return this.filtros.valorFiltro;
      },
      set(value) {
        this.filtros.valorFiltro = value;
      },
    },
  },

  methods: {
    handleDatalistInput(event) {
      const inputValue = event.target.value;
      this.valorFiltroTexto = inputValue;
      
      const opcionSeleccionada = this.opcionesFiltro.find(opcion => 
        opcion.nombre === inputValue
      );
      
      if (opcionSeleccionada) {
        this.valorFiltro = opcionSeleccionada.id;
      } else if (inputValue === "" || inputValue === this.defaultSelectText) {
        this.valorFiltro = "";
      } else {
        this.valorFiltro = "";
      }
    },

    resetearEstado() {
  this.intentoGenerar = false;
  this.datosReporte = [];
  this.datosAgrupados = [];
  this.datosAmpliados = null;
  this.reiniciarTotales();
  this.destroyCharts();
  this.valorFiltroTexto = "";
  this.totalesVentasCanceladas = {
    total_ventas: 0,
    total_monto: 0,
    total_extento: 0,
    gravado_15: 0,
    gravado_18: 0,
    total_isv: 0,
  };
  this.totalesCompras = {
    total_gravado_15: 0,
    total_exento: 0,
    total_subtotal: 0,
    total_descuento: 0,
    total_impuesto_15: 0,
    total_general: 0
  };
  this.totalesFiscales = {
    total_exentas: 0,
    total_gravadas_15: 0,
    total_gravadas_18: 0,
    total_impuesto_15: 0,
    total_impuesto_18: 0,
    total_general: 0
  };
  this.totalesFacturasSinSAR = {
    total_facturas: 0,
    total_extento: 0,
    total_gravado_15: 0,
    total_gravado_18: 0,
    total_isv: 0,
    total_general: 0
  };
  this.totalesProduccion = {
    total_ordenes: 0,
    total_completadas: 0,
    total_unidades: 0,
    costo_total: 0,
  };
},

    destroyCharts() {
      Object.values(this.charts).forEach(chart => {
        if (chart) {
          chart.destroy();
        }
      });
      this.charts = { horas: null, metodos: null };
    },

    async cargarDatos() {
      try {
        this.cargando = true;
        
        const [clientes, empleados, productos, sucursalesResponse] =
          await Promise.all([
            clientesReportes(this.id_usuario),
            reportesEmpleados(this.id_usuario, this.esCeo),
            reportesProductos(this.id_usuario, this.esCeo),
            sucursalReportes(this.id_usuario),
          ]);

        this.clientes = clientes || [];
        this.empleados = empleados || [];
        this.productos = productos || [];

        if (this.esCeo) {
          this.sucursales = sucursalesResponse || [];
        } else {
          this.sucursales = (sucursalesResponse && sucursalesResponse.length > 0) ? [sucursalesResponse[0]] : [];
          if (this.sucursales.length > 0) {
            this.sucursalAsignada = this.sucursales[0];
          }
        }
        
      } catch (error) {
        console.error("❌ Error al cargar datos:", error);
        notis("error", "Error al cargar datos: " + error.message);
      } finally {
        this.cargando = false;
      }
    },

    reiniciarTotales() {
      this.totales = {
        exento: 0,
        gravado_15: 0,
        gravado_18: 0,
        total_isv: 0,
        total: 0,
      };
    },

    setHoy() {
      const hoy = new Date().toISOString().split("T")[0];
      this.filtros.fechaInicio = hoy;
      this.filtros.fechaFin = hoy;
    },

    setSemana() {
      const fin = new Date();
      const inicio = new Date();
      inicio.setDate(fin.getDate() - 7);
      
      this.filtros.fechaInicio = inicio.toISOString().split("T")[0];
      this.filtros.fechaFin = fin.toISOString().split("T")[0];
    },

    setMes() {
      const fin = new Date();
      const inicio = new Date();
      inicio.setMonth(fin.getMonth() - 1);
      
      this.filtros.fechaInicio = inicio.toISOString().split("T")[0];
      this.filtros.fechaFin = fin.toISOString().split("T")[0];
    },

    validarFechas() {
      if (this.filtros.fechaInicio && this.filtros.fechaFin) {
        if (new Date(this.filtros.fechaFin) < new Date(this.filtros.fechaInicio)) {
          this.filtros.fechaFin = this.filtros.fechaInicio;
        }
      }
    },

    async generarReporte(formato = "preview") {
      if (!this.canGenerateReport) {
        notis("error", "Por favor verifique los filtros antes de generar el reporte");
        return;
      }

      this.cargando = true;
      this.error = null;
      this.isLoading = true;
      this.intentoGenerar = true;

      try {
        if (formato === "preview") {
          await this.generarReporteSegunTipo();
        } else if (formato === "pdf") {
          await this.exportarPDF();
          notis("success", "PDF generado con éxito");
        } else if (formato === "excel") {
          await this.exportarExcel();
        }
      } catch (error) {
        console.error("Error en generarReporte:", error);
        notis("error", "Error al generar el reporte");
        this.error = "Error al generar el reporte: " + error.message;
      } finally {
        this.cargando = false;
        this.isLoading = false;
      }
    },

    async generarReporteSegunTipo() {
  if (this.reporteSeleccionado === 'ventas_sucursal' && !this.esCeo) {
    notis("error", "No tienes permisos para acceder a este reporte");
    this.reporteSeleccionado = 'ventas_cliente';
    return;
  }

  switch (this.reporteSeleccionado) {
    case 'ventas_cliente':
    case 'ventas_sucursal':
    case 'ventas_empleado':
      await this.mostrarReportesVentas();
      break;
    case 'productos_vendidos':
      await this.mostrarProductosMasVendidos();
      break;
    case 'clientes_frecuentes':
      await this.mostrarClientesFrecuentes();
      break;
    case 'inventario_bajo':
      await this.mostrarInventarioBajoStock();
      break;
    case 'ventas_por_hora':
      await this.mostrarVentasPorHora();
      break;
    case 'metodos_pago':
      await this.mostrarMetodosPago();
      break;
    case 'ventas_canceladas':
      await this.mostrarVentasCanceladas();
      break;
    case 'devoluciones':
      await this.mostrarDevoluciones();
      break;
    case 'anulaciones':
      await this.mostrarAnulaciones();
      break;
    case 'reporte_compras':
      await this.mostrarReporteCompras();
      break;
    case 'reporte_fiscal':
      await this.mostrarReporteFiscal();
      break;
    case 'facturas_sin_sar':
      await this.mostrarFacturasSinSAR();
      break;
    case 'utilidad_bruta':
      await this.mostrarUtilidadBruta();
      break;
    case 'rotacion_inventario':
      await this.mostrarRotacionInventario();
      break;
    case 'comparativo_mensual':
      await this.mostrarComparativoMensual();
      break;
    case 'proyeccion_ventas':
      await this.mostrarProyeccionVentas();
      break;
    case 'ordenes_produccion':
      await this.mostrarOrdenesProduccion();
      break;
    case 'margen_produccion':
      await this.mostrarMargenProduccion();
      break;
    default:
      throw new Error('Tipo de reporte no válido');
  }
},

    async mostrarVentasCanceladas() {
      try {
        const response = await getVentasCanceladas(
          this.id_usuario,
          this.filtros.fechaInicio,
          this.filtros.fechaFin,
          this.filtros.limite,
          this.esCeo && this.valorFiltro ? this.valorFiltro : null // ✅ NUEVO
        );

        this.datosReporte = response.ventas_anuladas || [];
        this.totalesVentasCanceladas = response.totales || {
          total_ventas: 0,
          total_monto: 0,
          total_extento: 0,
          gravado_15: 0,
          gravado_18: 0,
          total_isv: 0,
        };
      } catch (error) {
        throw new Error('Error al cargar ventas canceladas: ' + error.message);
      }
    },

    async mostrarAnulaciones() {
      try {
        const data = await AdminVentas.getReporteAnulaciones({
          inicio: this.filtros.fechaInicio,
          fin:    this.filtros.fechaFin,
        });
        this.datosReporte = data;
      } catch (error) {
        throw new Error('Error al cargar anulaciones: ' + error.message);
      }
    },

    async mostrarDevoluciones() {
      try {
        const data = await AdminVentas.getReporteDevoluciones({
          inicio: this.filtros.fechaInicio,
          fin:    this.filtros.fechaFin,
        });
        this.datosReporte = data;
      } catch (error) {
        throw new Error('Error al cargar devoluciones: ' + error.message);
      }
    },

    async mostrarReporteCompras() {
      try {
        const response = await solicitudes.obtenerReporteCompras(
          this.id_usuario,
          this.filtros.fechaInicio,
          this.filtros.fechaFin,
          this.filtros.limite,
          this.esCeo && this.valorFiltro ? this.valorFiltro : null // ✅ NUEVO
        );

        this.datosReporte = response.compras || [];
        this.totalesCompras = response.totales || {
          total_gravado_15: 0,
          total_exento: 0,
          total_subtotal: 0,
          total_descuento: 0,
          total_impuesto_15: 0,
          total_general: 0
        };

      } catch (error) {
        console.error('❌ Error en mostrarReporteCompras:', error);
        this.error = 'Error al cargar reporte de compras: ' + error.message;
        notis("error", "Error al cargar reporte de compras");
        throw error;
      }
    },

    async mostrarReporteFiscal() {
  try {
    const response = await solicitudes.obtenerReporteFiscalVentas(
      this.id_usuario,
      this.filtros.fechaInicio,
      this.filtros.fechaFin,
      10000,
      this.esCeo && this.valorFiltro ? this.valorFiltro : null
    );

    this.datosReporte = response.ventas_por_dia || [];
    this.totalesFiscales = response.totales || {
      total_exentas: 0,
      total_gravadas_15: 0,
      total_gravadas_18: 0,  // ✅ NUEVO
      total_impuesto_15: 0,
      total_impuesto_18: 0,  // ✅ NUEVO
      total_general: 0
    };

  } catch (error) {
    console.error('❌ Error en mostrarReporteFiscal:', error);
    this.error = 'Error al cargar reporte fiscal: ' + error.message;
    notis("error", "Error al cargar reporte fiscal");
    throw error;
  }
},

    async mostrarReportesVentas() {
      try {
        let response;

        if (this.valorFiltro && this.valorFiltro !== "") {
          const opcionSeleccionada = this.opcionesFiltro.find(opt => opt.id === this.valorFiltro);
          if (opcionSeleccionada) {
            await this.mostrarReporteTotalCliente(opcionSeleccionada);
            return;
          }
        }

        switch (this.reporteSeleccionado) {
          case "ventas_empleado":
            response = await getRegistrosEmpleados(
              this.id_usuario,
              this.filtros.fechaInicio,
              this.filtros.fechaFin
            );
            break;
          case "ventas_cliente":
            response = await getRegistrosClientes(
              this.id_usuario,
              this.filtros.fechaInicio,
              this.filtros.fechaFin
            );
            break;
          case "ventas_sucursal":
            response = await getRegistrosSucursales(
              this.id_usuario,
              this.filtros.fechaInicio,
              this.filtros.fechaFin
            );
            break;
        }

        if (this.especificacion) {
          const desglosesPromises = response.map(async (item) => {
            let desglose;
            try {
              switch (this.reporteSeleccionado) {
                case "ventas_empleado":
                  desglose = await getRegistrosEmpleadosDesglose(
                    item.id,
                    this.filtros.fechaInicio,
                    this.filtros.fechaFin
                  );
                  break;
                case "ventas_cliente":
                  desglose = await getRegistrosClienteDesglose(
                    item.id,
                    this.filtros.fechaInicio,
                    this.filtros.fechaFin
                  );
                  break;
                case "ventas_sucursal":
                  desglose = await getRegistrosSucursalDesglose(
                    item.id,
                    this.filtros.fechaInicio,
                    this.filtros.fechaFin
                  );
                  break;
              }
              return { ...item, desglose: desglose || [] };
            } catch (error) {
              console.error(`Error obteniendo desglose para ${item.nombre}:`, error);
              return { ...item, desglose: [] };
            }
          });

          this.datosAgrupados = await Promise.all(desglosesPromises);
        } else {
          this.datosAgrupados = response.map(item => ({ ...item, desglose: [] }));
        }

        this.datosReporte = response;
        this.calcularTotales(response);
      } catch (error) {
        throw new Error('Error al cargar reportes de ventas: ' + error.message);
      }
    },

    async mostrarProductosMasVendidos() {
      try {
        const response = await getProductosMasVendidos(
          this.id_usuario,
          this.filtros.fechaInicio,
          this.filtros.fechaFin,
          this.filtros.limite,
          false,
          this.esCeo && this.valorFiltro ? this.valorFiltro : null // ✅ NUEVO
        );
        this.datosReporte = response;
      } catch (error) {
        throw new Error('Error al cargar productos más vendidos: ' + error.message);
      }
    },

    async mostrarClientesFrecuentes() {
      try {
        const response = await getClientesFrecuentes(
          this.id_usuario,
          this.filtros.fechaInicio,
          this.filtros.fechaFin,
          this.filtros.limite,
          this.esCeo && this.valorFiltro ? this.valorFiltro : null // ✅ NUEVO
        );
        this.datosReporte = response;
      } catch (error) {
        throw new Error('Error al cargar clientes frecuentes: ' + error.message);
      }
    },

    async mostrarInventarioBajoStock() {
      try {
        const response = await getInventarioBajoStock(
          this.id_usuario,
          this.filtros.limite
        );
        this.datosReporte = response;
      } catch (error) {
        throw new Error('Error al cargar inventario bajo stock: ' + error.message);
      }
    },

    async mostrarVentasPorHora() {
      try {
        const response = await getVentasPorHora(
          this.id_usuario,
          this.filtros.fechaInicio,
          this.filtros.fechaFin,
          this.esCeo && this.valorFiltro ? this.valorFiltro : null // ✅ NUEVO
        );
        this.datosReporte = response;
        
        this.$nextTick(() => {
          this.createHorasChart();
        });
      } catch (error) {
        throw new Error('Error al cargar ventas por hora: ' + error.message);
      }
    },

    async mostrarMetodosPago() {
      try {
        const response = await getReporteMetodosPago(
          this.id_usuario,
          this.filtros.fechaInicio,
          this.filtros.fechaFin,
          this.esCeo && this.valorFiltro ? this.valorFiltro : null // ✅ NUEVO
        );
        this.datosReporte = response;
        
        this.$nextTick(() => {
          this.createMetodosChart();
        });
      } catch (error) {
        throw new Error('Error al cargar métodos de pago: ' + error.message);
      }
    },
    async mostrarFacturasSinSAR() {
  try {
    const response = await solicitudes.obtenerFacturasSinSAR(
      this.id_usuario,
      this.filtros.fechaInicio,
      this.filtros.fechaFin,
      this.filtros.limite,
      this.esCeo && this.valorFiltro ? this.valorFiltro : null
    );

    this.datosReporte = response.facturas_sin_sar || [];
    this.totalesFacturasSinSAR = response.totales || {
      total_facturas: 0,
      total_extento: 0,
      total_gravado_15: 0,
      total_gravado_18: 0,
      total_isv: 0,
      total_general: 0
    };

  } catch (error) {
    console.error('❌ Error en mostrarFacturasSinSAR:', error);
    this.error = 'Error al cargar facturas sin SAR: ' + error.message;
    notis("error", "Error al cargar facturas sin SAR");
    throw error;
  }
},

    async mostrarUtilidadBruta() {
      try {
        const token = localStorage.getItem('auth');
        const userId = token ? JSON.parse(atob(token.split('.')[1])).id_usuario : this.id_usuario;
        const raw = await getUtilidadBruta(userId, this.filtros.fechaInicio, this.filtros.fechaFin);
        const arr = Array.isArray(raw) ? raw : [];
        const filas = arr.map(r => ({
          producto: r.nombre,
          unidades_vendidas: r.cantidad_vendida,
          precio_promedio: r.cantidad_vendida > 0 ? +(r.ingresos / r.cantidad_vendida).toFixed(2) : 0,
          costo_promedio: r.cantidad_vendida > 0 ? +(r.costo_total / r.cantidad_vendida).toFixed(2) : 0,
          total_ventas: r.ingresos,
          total_costo: r.costo_total,
          utilidad: r.utilidad_bruta,
          margen: r.margen_pct
        }));
        const tv = filas.reduce((s, f) => s + f.total_ventas, 0);
        const tc = filas.reduce((s, f) => s + f.total_costo, 0);
        const ub = +(tv - tc).toFixed(2);
        const tu = filas.reduce((s, f) => s + f.unidades_vendidas, 0);
        const mp = tv > 0 ? +((ub / tv) * 100).toFixed(2) : 0;
        this.datosAmpliados = {
          filas,
          totales: { total_ventas: +tv.toFixed(2), total_costo: +tc.toFixed(2), utilidad_bruta: ub, total_unidades: tu, margen_promedio: mp }
        };
        this.datosReporte = filas;
      } catch (error) {
        throw new Error('Error al cargar utilidad bruta: ' + error.message);
      }
    },

    async mostrarRotacionInventario() {
      try {
        const token = localStorage.getItem('auth');
        const userId = token ? JSON.parse(atob(token.split('.')[1])).id_usuario : this.id_usuario;
        const raw = await getRotacionInventario(userId, this.diasRotacion);
        const arr = Array.isArray(raw) ? raw : [];
        const filas = arr.map(r => ({
          producto: r.nombre,
          categoria: r.sucursal || '',
          stock_actual: r.stock_actual,
          precio_venta: r.precio_unitario,
          valor_inventario: +(r.stock_actual * r.precio_unitario).toFixed(2),
          ultima_venta: r.ultima_venta || null,
          dias_sin_ventas: r.dias_sin_venta
        }));
        this.datosAmpliados = null;
        this.datosReporte = filas;
      } catch (error) {
        throw new Error('Error al cargar rotación de inventario: ' + error.message);
      }
    },

    async mostrarComparativoMensual() {
      try {
        const token = localStorage.getItem('auth');
        const userId = token ? JSON.parse(atob(token.split('.')[1])).id_usuario : this.id_usuario;
        const raw = await getComparativoMensual(userId, this.mesesComparativo);
        const arr = Array.isArray(raw) ? raw : [];
        const mesesNombres = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
        const meses = arr.map(m => {
          const [anio, mes] = m.mes.split('-');
          return {
            mes_nombre: `${mesesNombres[parseInt(mes) - 1]} ${anio}`,
            total_ventas: m.total,
            total_transacciones: m.cantidad_ventas,
            ticket_promedio: m.cantidad_ventas > 0 ? +(m.total / m.cantidad_ventas).toFixed(2) : 0
          };
        });
        this.datosAmpliados = { meses };
        this.datosReporte = meses;
      } catch (error) {
        throw new Error('Error al cargar comparativo mensual: ' + error.message);
      }
    },

    async mostrarProyeccionVentas() {
      try {
        const token = localStorage.getItem('auth');
        const userId = token ? JSON.parse(atob(token.split('.')[1])).id_usuario : this.id_usuario;
        const data = await getProyeccionVentas(userId, this.diasHistoricoProyeccion);
        this.proyeccionData = data;
        this.datosAmpliados = null;
        // Put all in datosReporte for export
        this.datosReporte = [
          ...( data.historico || []).map(d => ({ ...d, tipo: 'Histórico' })),
          ...( data.proyeccion || []).map(d => ({ ...d, tipo: 'Proyectado' })),
        ];
      } catch (error) {
        throw new Error('Error al cargar proyección de ventas: ' + error.message);
      }
    },

    async mostrarOrdenesProduccion() {
      try {
        const ordenes = await getOrdenesProduccion(this.id_usuario, {
          fecha_inicio: this.filtros.fechaInicio,
          fecha_fin:    this.filtros.fechaFin,
          limite:       this.filtros.limite,
        });
        const arr = Array.isArray(ordenes) ? ordenes : [];
        this.datosReporte = arr.map(o => ({
          id_orden:        o.id_orden,
          fecha:           o.created_at,
          receta:          o.receta?.nombre || '—',
          producto:        o.receta?.producto?.nombre || '—',
          cantidad:        o.cantidad_a_producir,
          estado:          o.estado,
          costo_total:     Number(o.costo_total || 0),
          costo_por_unidad: Number(o.costo_por_unidad || 0),
          precio_sugerido: Number(o.precio_sugerido || 0),
          precio_actual:   Number(o.receta?.producto?.precio_unitario || 0),
          margen_pct:      o.precio_sugerido && o.costo_por_unidad
            ? +(((o.precio_sugerido - o.costo_por_unidad) / o.precio_sugerido) * 100).toFixed(1)
            : 0,
          usuario:         o.usuario ? `${o.usuario.nombre} ${o.usuario.apellido}` : '—',
          sucursal:        o.sucursal?.nombre_administrativo || '—',
        }));
        this.totalesProduccion = {
          total_ordenes:    arr.length,
          total_completadas: arr.filter(o => o.estado === 'completada').length,
          total_unidades:   arr.filter(o => o.estado === 'completada').reduce((s, o) => s + Number(o.cantidad_a_producir || 0), 0),
          costo_total:      arr.filter(o => o.estado === 'completada').reduce((s, o) => s + Number(o.costo_total || 0), 0),
        };
      } catch (error) {
        throw new Error('Error al cargar órdenes de producción: ' + error.message);
      }
    },

    async mostrarMargenProduccion() {
      try {
        const ordenes = await getOrdenesProduccion(this.id_usuario, {
          fecha_inicio: this.filtros.fechaInicio,
          fecha_fin:    this.filtros.fechaFin,
          estado:       'completada',
          limite:       1000,
        });
        const arr = Array.isArray(ordenes) ? ordenes : [];
        const mapa = {};
        for (const o of arr) {
          const key = o.id_receta || o.receta?.nombre || '?';
          if (!mapa[key]) {
            mapa[key] = {
              receta:           o.receta?.nombre || '—',
              producto:         o.receta?.producto?.nombre || '—',
              precio_actual:    Number(o.receta?.producto?.precio_unitario || 0),
              ordenes:          0,
              total_unidades:   0,
              costo_total:      0,
              suma_cpu:         0,
            };
          }
          mapa[key].ordenes++;
          mapa[key].total_unidades += Number(o.cantidad_a_producir || 0);
          mapa[key].costo_total    += Number(o.costo_total || 0);
          mapa[key].suma_cpu       += Number(o.costo_por_unidad || 0);
        }
        this.datosReporte = Object.values(mapa).map(r => {
          const cpu = r.ordenes > 0 ? r.suma_cpu / r.ordenes : 0;
          const margen = r.precio_actual > cpu
            ? +(((r.precio_actual - cpu) / r.precio_actual) * 100).toFixed(1)
            : 0;
          return { ...r, costo_por_unidad: +cpu.toFixed(2), margen_pct: margen };
        }).sort((a, b) => b.costo_total - a.costo_total);
        this.totalesProduccion = {
          total_ordenes:    arr.length,
          total_completadas: arr.length,
          total_unidades:   arr.reduce((s, o) => s + Number(o.cantidad_a_producir || 0), 0),
          costo_total:      arr.reduce((s, o) => s + Number(o.costo_total || 0), 0),
        };
      } catch (error) {
        throw new Error('Error al cargar margen de producción: ' + error.message);
      }
    },

    fmtNum(n) {
      return Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2 });
    },

    ampBarWidth(val) {
      if (!this.datosAmpliados?.meses?.length) return 0;
      const max = Math.max(...this.datosAmpliados.meses.map(m => m.total_ventas));
      return max > 0 ? (val / max * 100) : 0;
    },

    ampVariacion(actual, anterior) {
      if (!anterior?.total_ventas) return 0;
      return ((actual.total_ventas - anterior.total_ventas) / anterior.total_ventas * 100).toFixed(1);
    },

    async mostrarReporteTotalCliente(option) {
      try {
        let detallesResponse;

        switch (this.reporteSeleccionado) {
          case "ventas_empleado":
            detallesResponse = await getRegistrosEmpleadosDesglose(
              option.id,
              this.filtros.fechaInicio,
              this.filtros.fechaFin
            );
            break;
          case "ventas_cliente":
            detallesResponse = await getRegistrosClienteDesglose(
              option.id,
              this.filtros.fechaInicio,
              this.filtros.fechaFin
            );
            break;
          case "ventas_sucursal":
            detallesResponse = await getRegistrosSucursalDesglose(
              option.id,
              this.filtros.fechaInicio,
              this.filtros.fechaFin
            );
            break;
        }

        this.datosAgrupados = [{
          nombre: option.nombre,
          valor_exento: detallesResponse.reduce((sum, item) => sum + (item.valor_exento || 0), 0),
          gravado_15: detallesResponse.reduce((sum, item) => sum + (item.gravado_15 || 0), 0),
          gravado_18: detallesResponse.reduce((sum, item) => sum + (item.gravado_18 || 0), 0),
          total_isv: detallesResponse.reduce((sum, item) => sum + (item.total_isv || 0), 0),
          total: detallesResponse.reduce((sum, item) => sum + (item.total || 0), 0),
          desglose: detallesResponse.map(factura => ({
            id: factura.id,
            nombre: factura.nombre,
            valor_exento: factura.valor_exento || 0,
            gravado_15: factura.gravado_15 || 0,
            gravado_18: factura.gravado_18 || 0,
            total_isv: factura.total_isv || 0,
            total: factura.total || 0,
          })),
        }];

        this.datosReporte = detallesResponse;
        this.calcularTotales([this.datosAgrupados[0]]);
      } catch (error) {
        throw new Error('Error al cargar datos del reporte específico: ' + error.message);
      }
    },

    calcularTotales(datos) {
      this.totales = datos.reduce((acc, curr) => ({
        exento: acc.exento + (curr.valor_exento || curr.valor_extento || 0),
        gravado_15: acc.gravado_15 + (curr.gravado_15 || 0),
        gravado_18: acc.gravado_18 + (curr.gravado_18 || 0),
        total_isv: acc.total_isv + (curr.total_isv || 0),
        total: acc.total + (curr.total || 0),
      }), {
        exento: 0,
        gravado_15: 0,
        gravado_18: 0,
        total_isv: 0,
        total: 0,
      });
    },

    async createHorasChart() {
      const Chart = await import('chart.js/auto');
      
      if (this.charts.horas) {
        this.charts.horas.destroy();
      }

      const ctx = this.$refs.horasChart;
      if (!ctx) return;

      const data = this.datosReporte.map(item => ({
        x: item.hora,
        y: item.cantidad_ventas
      }));

      this.charts.horas = new Chart.default(ctx, {
        type: 'line',
        data: {
          datasets: [{
            label: 'Ventas por Hora',
            data: data,
            borderColor: 'rgb(13, 148, 136)',
            backgroundColor: 'rgba(13, 148, 136, 0.15)',
            tension: 0.1
          }]
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Distribución de Ventas por Hora del Día'
            }
          },
          scales: {
            x: {
              title: {
                display: true,
                text: 'Hora del Día'
              }
            },
            y: {
              title: {
                display: true,
                text: 'Cantidad de Ventas'
              }
            }
          }
        }
      });
    },

    async createMetodosChart() {
      const Chart = await import('chart.js/auto');
      
      if (this.charts.metodos) {
        this.charts.metodos.destroy();
      }

      const ctx = this.$refs.metodosChart;
      if (!ctx) return;

      const labels = this.datosReporte.map(item => item.metodo_pago);
      const data = this.datosReporte.map(item => item.cantidad_transacciones);

      this.charts.metodos = new Chart.default(ctx, {
        type: 'doughnut',
        data: {
          labels: labels,
          datasets: [{
            data: data,
            backgroundColor: [
              '#DC2626',
              '#1D6FBF',
              '#D97706',
              '#0D9488',
              '#9966FF',
              '#FF9F40'
            ]
          }]
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Distribución de Métodos de Pago'
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      });
    },

    async exportarPDF() {
      try {
        const orientation = this.reporteSeleccionado === 'reporte_fiscal' 
          ? 'landscape' 
          : 'portrait';
        
        const doc = new jsPDF({
          orientation: orientation,
          unit: 'mm',
          format: 'letter'
        });
            
        if (this.logoUrl) {
          try {
            doc.addImage(this.logoUrl, 'JPEG', 15, 10, 30, 20);
          } catch {
            // si el logo falla no interrumpir el PDF
          }
        }

        doc.setFontSize(16);
        doc.text(this.datosBussines.nombre || 'Empresa', this.logoUrl ? 50 : 15, 20);
        
        doc.setFontSize(10);
        if (this.datosBussines.direccion) {
          doc.text(this.datosBussines.direccion, this.logoUrl ? 50 : 15, 25);
        }
        if (this.datosBussines.telefono) {
          doc.text(`Tel: ${this.datosBussines.telefono}`, this.logoUrl ? 50 : 15, 30);
        }

        doc.setFontSize(14);
        const titulosReporte = {
          ventas_cliente: 'REPORTE DE VENTAS POR CLIENTE',
          ventas_sucursal: 'REPORTE DE VENTAS POR SUCURSAL',
          ventas_empleado: 'REPORTE DE VENTAS POR EMPLEADO',
          productos_vendidos: 'REPORTE DE PRODUCTOS MÁS VENDIDOS',
          clientes_frecuentes: 'REPORTE DE CLIENTES FRECUENTES',
          inventario_bajo: 'REPORTE DE INVENTARIO BAJO STOCK',
          ventas_por_hora: 'REPORTE DE VENTAS POR HORA',
          metodos_pago: 'REPORTE DE MÉTODOS DE PAGO',
          ventas_canceladas: 'REPORTE DE VENTAS CANCELADAS',
          anulaciones: 'REPORTE DE ANULACIONES',
          reporte_compras: 'REPORTE DE COMPRAS',
          reporte_fiscal: 'REPORTE FISCAL DE VENTAS',
          rotacion_inventario:  'REPORTE DE ROTACIÓN DE INVENTARIO',
          comparativo_mensual:  'REPORTE COMPARATIVO MENSUAL',
          utilidad_bruta:       'REPORTE DE UTILIDAD BRUTA',
          devoluciones:         'REPORTE DE DEVOLUCIONES',
          ordenes_produccion:   'ÓRDENES DE PRODUCCIÓN',
          margen_produccion:    'RENDIMIENTO POR RECETA',
        };
        
        let titulo = titulosReporte[this.reporteSeleccionado] || 'REPORTE';
        if (this.especificacion && this.isTraditionalSalesReport) {
          titulo += ' (DETALLADO)';
        }
        
        doc.text(titulo, 15, 45);
        
        doc.setFontSize(10);
        if (this.fechasValidas) {
          doc.text(`Período: ${this.formatearFecha(this.filtros.fechaInicio)} - ${this.formatearFecha(this.filtros.fechaFin)}`, 15, 50);
        }
        doc.text(`Generado: ${new Date().toLocaleDateString()}`, 15, 55);

        let startY = 65;

        if (this.isTraditionalSalesReport) {
          await this.generarTablaPDFVentas(doc, startY);
        } else {
          await this.generarTablaPDFOtrosReportes(doc, startY);
        }

        const fechaArchivo = new Date().toISOString().split('T')[0];
        const especificacionSuffix = this.especificacion && this.isTraditionalSalesReport ? '-detallado' : '';
        const nombreArchivo = `reporte-${this.reporteSeleccionado}${especificacionSuffix}-${fechaArchivo}.pdf`;
        doc.save(nombreArchivo);
        
        notis("success", "PDF generado exitosamente");
      } catch (error) {
        console.error("Error generando PDF:", error);
        notis("error", "Error al generar el PDF");
      }
    },

    async generarTablaPDFVentas(doc, startY) {
      if (this.especificacion && this.datosAgrupados.some(grupo => grupo.desglose && grupo.desglose.length > 0)) {
        await this.generarTablaPDFVentasConDesglose(doc, startY);
      } else {
        await this.generarTablaPDFVentasSinDesglose(doc, startY);
      }
    },

    async generarTablaPDFVentasSinDesglose(doc, startY) {
      const tableData = this.datosAgrupados.map(item => [
        item.nombre,
        this.formatearMoneda(item.valor_exento || item.valor_extento || 0),
        this.formatearMoneda(item.gravado_15 || 0),
        this.formatearMoneda(item.gravado_18 || 0),
        this.formatearMoneda(item.total_isv || 0),
        this.formatearMoneda(item.total || 0)
      ]);

      doc.autoTable({
        head: [[this.labelFiltro, 'Exento', 'Gravado 15%', 'Gravado 18%', 'ISV', 'Total']],
        body: tableData,
        startY: startY,
        styles: {
          fontSize: 8,
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          fontStyle: 'bold'
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245]
        },
        columnStyles: {
          1: { halign: 'right' },
          2: { halign: 'right' },
          3: { halign: 'right' },
          4: { halign: 'right' },
          5: { halign: 'right' }
        }
      });

      const finalY = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.text('TOTALES:', 15, finalY);
      doc.setFontSize(10);
      doc.text(`Exento: ${this.formatearMoneda(this.totales.exento)}`, 15, finalY + 5);
      doc.text(`Gravado 15%: ${this.formatearMoneda(this.totales.gravado_15)}`, 15, finalY + 10);
      doc.text(`Gravado 18%: ${this.formatearMoneda(this.totales.gravado_18)}`, 15, finalY + 15);
      doc.text(`ISV: ${this.formatearMoneda(this.totales.total_isv)}`, 15, finalY + 20);
      doc.text(`TOTAL GENERAL: ${this.formatearMoneda(this.totales.total)}`, 15, finalY + 25);
    },

    async generarTablaPDFVentasConDesglose(doc, startY) {
      let currentY = startY;

      for (let i = 0; i < this.datosAgrupados.length; i++) {
        const grupo = this.datosAgrupados[i];
        
        if (currentY > 250) {
          doc.addPage();
          currentY = 20;
        }

        const resumenData = [[
          grupo.nombre,
          this.formatearMoneda(grupo.valor_exento || grupo.valor_extento || 0),
          this.formatearMoneda(grupo.gravado_15 || 0),
          this.formatearMoneda(grupo.gravado_18 || 0),
          this.formatearMoneda(grupo.total_isv || 0),
          this.formatearMoneda(grupo.total || 0)
        ]];

        doc.autoTable({
          head: [[this.labelFiltro, 'Exento', 'Gravado 15%', 'Gravado 18%', 'ISV', 'Total']],
          body: resumenData,
          startY: currentY,
          styles: {
            fontSize: 9,
            cellPadding: 3,
          },
          headStyles: {
            fillColor: [41, 128, 185],
            textColor: 255,
            fontStyle: 'bold'
          },
          bodyStyles: {
            fillColor: [230, 244, 255],
            fontStyle: 'bold'
          },
          columnStyles: {
            1: { halign: 'right' },
            2: { halign: 'right' },
            3: { halign: 'right' },
            4: { halign: 'right' },
            5: { halign: 'right' }
          }
        });

        currentY = doc.lastAutoTable.finalY + 5;

        if (grupo.desglose && grupo.desglose.length > 0) {
          doc.setFontSize(10);
          doc.setFont(undefined, 'bold');
          doc.text(`Facturas de ${grupo.nombre}`, 15, currentY);
          currentY += 8;

          const facturaData = grupo.desglose.map(factura => [
            factura.nombre,
            this.formatearMoneda(factura.valor_exento || 0),
            this.formatearMoneda(factura.gravado_15 || 0),
            this.formatearMoneda(factura.gravado_18 || 0),
            this.formatearMoneda(factura.total_isv || 0),
            this.formatearMoneda(factura.total || 0)
          ]);

          doc.autoTable({
            head: [['Número de Factura', 'Exento', 'Gravado 15%', 'Gravado 18%', 'ISV', 'Total']],
            body: facturaData,
            startY: currentY,
            styles: {
              fontSize: 8,
              cellPadding: 2,
            },
            headStyles: {
              fillColor: [52, 144, 220],
              textColor: 255,
              fontStyle: 'bold',
              fontSize: 8
            },
            alternateRowStyles: {
              fillColor: [248, 249, 250]
            },
            columnStyles: {
              0: { 
                cellWidth: 50,
                fontStyle: 'bold'
              },
              1: { halign: 'right', cellWidth: 25 },
              2: { halign: 'right', cellWidth: 25 },
              3: { halign: 'right', cellWidth: 25 },
              4: { halign: 'right', cellWidth: 20 },
              5: { halign: 'right', cellWidth: 25 }
            },
            margin: { left: 20 }
          });

          currentY = doc.lastAutoTable.finalY + 10;
        }

        if (i < this.datosAgrupados.length - 1) {
          doc.setDrawColor(200, 200, 200);
          doc.line(15, currentY, 195, currentY);
          currentY += 10;
        }
      }

      currentY += 10;

      if (currentY > 240) {
        doc.addPage();
        currentY = 20;
      }

      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.text('TOTALES GENERALES:', 15, currentY);

      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.text(`Exento: ${this.formatearMoneda(this.totales.exento)}`, 15, currentY + 10);
      doc.text(`Gravado 15%: ${this.formatearMoneda(this.totales.gravado_15)}`, 15, currentY + 15);
      doc.text(`Gravado 18%: ${this.formatearMoneda(this.totales.gravado_18)}`, 15, currentY + 20);
      doc.text(`ISV: ${this.formatearMoneda(this.totales.total_isv)}`, 15, currentY + 25);

      doc.setFont(undefined, 'bold');
      doc.text(`TOTAL GENERAL: ${this.formatearMoneda(this.totales.total)}`, 15, currentY + 35);
    },

    async generarTablaPDFOtrosReportes(doc, startY) {
  let tableData = [];
  let headers = [];

  switch (this.reporteSeleccionado) {
    case 'productos_vendidos':
      headers = ['#', 'Producto', 'Código', 'Cantidad', 'Total Vendido', 'Precio Unit.'];
      tableData = this.datosReporte.map((producto, index) => [
        index + 1,
        producto.nombre,
        producto.codigo,
        this.formatearCantidad(producto.cantidad_vendida),
        this.formatearMoneda(producto.total_vendido),
        this.formatearMoneda(producto.precio_unitario)
      ]);
      break;

    case 'clientes_frecuentes':
      headers = ['#', 'Cliente', 'Visitas', 'Monto Total', 'Promedio', 'Última Visita'];
      tableData = this.datosReporte.map((cliente, index) => [
        index + 1,
        cliente.nombre,
        cliente.numero_visitas,
        this.formatearMoneda(cliente.monto_total),
        this.formatearMoneda(cliente.promedio_compra),
        this.formatearFecha(cliente.ultima_visita)
      ]);
      break;

    case 'inventario_bajo':
      headers = ['Producto', 'Sucursal', 'Stock Actual', 'Stock Mín.', 'Estado', 'Precio'];
      tableData = this.datosReporte.map(item => [
        item.nombre_producto,
        item.sucursal,
        item.stock_actual,
        item.stock_minimo,
        item.estado_critico,
        this.formatearMoneda(item.precio_unitario)
      ]);
      break;

    case 'ventas_por_hora':
      headers = ['Hora', 'Cantidad Ventas', 'Total Vendido', 'Promedio'];
      tableData = this.datosReporte.map(hora => [
        hora.hora_formato,
        hora.cantidad_ventas,
        this.formatearMoneda(hora.total_ventas),
        this.formatearMoneda(hora.promedio_venta)
      ]);
      break;

    case 'metodos_pago':
      headers = ['Método', 'Transacciones', 'Monto Total', 'Porcentaje'];
      tableData = this.datosReporte.map(metodo => [
        metodo.metodo_pago,
        metodo.cantidad_transacciones,
        this.formatearMoneda(metodo.total_monto),
        metodo.porcentaje + '%'
      ]);
      break;

    case 'ventas_canceladas':
      headers = ['Factura', 'Empleado', 'Cliente', 'Sucursal', 'Total', 'Fecha', 'Motivo'];
      tableData = this.datosReporte.map(venta => [
        venta.numero_factura,
        venta.empleado,
        venta.cliente,
        venta.sucursal,
        this.formatearMoneda(venta.total),
        this.formatearFecha(venta.fecha_anulacion),
        venta.motivo_cancelacion || 'N/A'
      ]);
      break;

    case 'anulaciones':
      headers = ['Factura', 'Monto', 'Tipo pago', 'Cajero', 'Cancelado por', 'Motivo', 'Fecha'];
      tableData = this.datosReporte.map(f => [
        f.facturas?.[0]?.codigo_factura || '—',
        this.formatearMoneda(f.facturas?.[0]?.total || 0),
        f.facturas?.[0]?.tipo_factura || '—',
        f.Usuarios ? `${f.Usuarios.nombre} ${f.Usuarios.apellido}` : '—',
        f.cancelado_por || '—',
        (f.descripcion || '—').slice(0, 60),
        this.formatearFecha(f.cancelado_at || f.created_at),
      ]);
      break;

    case 'devoluciones':
      headers = ['Número NC', 'Factura original', 'Monto', 'Motivo', 'Productos', 'Generado por', 'Estado', 'Fecha'];
      tableData = this.datosReporte.map(d => [
        d.numero_nota_credito || '—',
        d.Ventas?.facturas?.[0]?.codigo_factura || '—',
        this.formatearMoneda(d.monto_devuelto),
        d.motivo || '—',
        (d.detalle_devoluciones||[]).map(x=>`${x.producto?.nombre||'Item'} ×${x.cantidad_devuelta}`).join(', ') || '—',
        d.Usuarios ? `${d.Usuarios.nombre} ${d.Usuarios.apellido}` : '—',
        d.aplicada ? 'Aplicada' : 'Pendiente',
        this.formatearFecha(d.created_at),
      ]);
      break;

    case 'reporte_compras':
      headers = ['No.', 'Fecha', 'Proveedor', 'RTN', 'CAI', '# Factura', 'Gravado 15%', 'Exento', 'Subtotal', 'Descuento', 'Impuesto 15%', 'Total'];
      tableData = this.datosReporte.map((compra, index) => [
        index + 1,
        this.formatearFecha(compra.fecha),
        compra.proveedor,
        compra.rtn,
        compra.cai,
        compra.numero_factura,
        this.formatearMoneda(compra.gravado_15),
        this.formatearMoneda(compra.valor_exento),
        this.formatearMoneda(compra.subtotal),
        this.formatearMoneda(compra.descuento),
        this.formatearMoneda(compra.impuesto_15),
        this.formatearMoneda(compra.total)
      ]);
      break;

    // ✅ NUEVO: Caso para facturas sin SAR
    case 'facturas_sin_sar':
      headers = ['No. Temporal', 'Fecha', 'Estado', 'Empleado', 'Cliente', 'Sucursal', 'Exento', 'Gravado 15%', 'Gravado 18%', 'ISV', 'Total'];
      tableData = this.datosReporte.map(factura => [
        factura.numero_temporal,
        this.formatearFecha(factura.fecha),
        factura.estado,
        factura.empleado,
        factura.cliente,
        factura.sucursal,
        this.formatearMoneda(factura.total_extento),
        this.formatearMoneda(factura.gravado_15),
        this.formatearMoneda(factura.gravado_18),
        this.formatearMoneda(factura.total_isv),
        this.formatearMoneda(factura.total)
      ]);
      break;

    case 'ordenes_produccion':
      headers = ['#', 'Fecha', 'Receta', 'Producto', 'Cantidad', 'Estado', 'Costo Total', 'Costo/Ud', 'Precio Actual', 'Margen %'];
      tableData = this.datosReporte.map((o, i) => [
        i + 1,
        this.formatearFecha(o.fecha),
        o.receta,
        o.producto,
        o.cantidad,
        o.estado,
        'L. ' + this.fmtNum(o.costo_total),
        'L. ' + this.fmtNum(o.costo_por_unidad),
        'L. ' + this.fmtNum(o.precio_actual),
        o.margen_pct + '%',
      ]);
      break;

    case 'margen_produccion':
      headers = ['Receta', 'Producto', 'Órdenes', 'Uds. Producidas', 'Costo Total', 'Costo/Unidad', 'Precio Actual', 'Margen %'];
      tableData = this.datosReporte.map(r => [
        r.receta,
        r.producto,
        r.ordenes,
        this.fmtNum(r.total_unidades),
        'L. ' + this.fmtNum(r.costo_total),
        'L. ' + this.fmtNum(r.costo_por_unidad),
        'L. ' + this.fmtNum(r.precio_actual),
        r.margen_pct + '%',
      ]);
      break;

    case 'rotacion_inventario':
      headers = ['Producto', 'Sucursal', 'Stock Actual', 'Precio Venta', 'Valor Inventario', 'Días sin Ventas'];
      tableData = this.datosReporte.map(item => [
        item.producto,
        item.categoria || '—',
        item.stock_actual,
        this.formatearMoneda(item.precio_venta),
        this.formatearMoneda(item.valor_inventario),
        item.dias_sin_ventas ?? '—'
      ]);
      break;

    case 'comparativo_mensual': {
      const meses = this.datosReporte;
      const maxVal = Math.max(...meses.map(m => m.total_ventas), 1);

      // ── Gráfico de barras ──
      const chartX    = 15;
      const chartH    = 55;
      const chartW    = 181;
      const barCount  = meses.length;
      const slotW     = chartW / barCount;
      const barW      = Math.max(4, Math.min(18, slotW * 0.55));
      const baselineY = startY + chartH;

      // Título del gráfico
      doc.setFontSize(9);
      doc.setTextColor(60, 60, 60);
      doc.text('Ventas por Mes (L.)', chartX, startY - 3);

      // Línea base
      doc.setDrawColor(180, 180, 180);
      doc.setLineWidth(0.3);
      doc.line(chartX, baselineY, chartX + chartW, baselineY);

      meses.forEach((mes, i) => {
        const ratio  = mes.total_ventas / maxVal;
        const bH     = Math.max(1, ratio * (chartH - 10));
        const bX     = chartX + i * slotW + (slotW - barW) / 2;
        const bY     = baselineY - bH;

        // Barra
        doc.setFillColor(41, 128, 185);
        doc.rect(bX, bY, barW, bH, 'F');

        // Valor encima
        doc.setFontSize(5.5);
        doc.setTextColor(40, 40, 40);
        const label = 'L.' + Number(mes.total_ventas).toLocaleString('es-HN', { minimumFractionDigits: 0 });
        doc.text(label, bX + barW / 2, bY - 1.5, { align: 'center' });

        // Mes debajo
        doc.setFontSize(5.5);
        doc.text(mes.mes_nombre.split(' ')[0].substring(0, 3), bX + barW / 2, baselineY + 4, { align: 'center' });
        doc.text(mes.mes_nombre.split(' ')[1] || '', bX + barW / 2, baselineY + 7.5, { align: 'center' });
      });

      doc.setTextColor(0, 0, 0);
      const tableStartY = baselineY + 14;

      // Tabla debajo del gráfico
      doc.autoTable({
        head: [['Mes', 'Total Ventas', 'Transacciones', 'Promedio por Venta', 'Variación']],
        body: meses.map((m, i) => {
          let variacion = '—';
          if (i > 0) {
            const prev = meses[i - 1].total_ventas;
            if (prev > 0) {
              const pct = ((m.total_ventas - prev) / prev * 100).toFixed(2);
              variacion = (pct >= 0 ? '+' : '') + pct + '%';
            }
          } else {
            variacion = 'Base';
          }
          return [
            m.mes_nombre,
            this.formatearMoneda(m.total_ventas),
            m.total_transacciones,
            this.formatearMoneda(m.ticket_promedio),
            variacion,
          ];
        }),
        startY: tableStartY,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        columnStyles: {
          1: { halign: 'right' },
          2: { halign: 'center' },
          3: { halign: 'right' },
          4: { halign: 'center' },
        },
      });
      return;
    }

    case 'reporte_fiscal': {
      const fiscalHeaders = [
        [
          { content: 'Fecha', rowSpan: 2, styles: { halign: 'center', valign: 'middle' } },
          { content: '# de Factura', colSpan: 2, styles: { halign: 'center' } },
          { content: 'Ventas', colSpan: 5, styles: { halign: 'center' } },
          { content: 'Total', rowSpan: 2, styles: { halign: 'center', valign: 'middle' } }
        ],
        [
          { content: 'Desde', styles: { halign: 'center' } },
          { content: 'Hasta', styles: { halign: 'center' } },
          { content: 'Exentas', styles: { halign: 'center' } },
          { content: 'Gravadas 15%', styles: { halign: 'center' } },
          { content: 'Impuesto 15%', styles: { halign: 'center' } },
          { content: 'Gravadas 18%', styles: { halign: 'center' } },
          { content: 'Impuesto 18%', styles: { halign: 'center' } }
        ]
      ];

      tableData = this.datosReporte.map(dia => [
        this.formatearFecha(dia.fecha),
        dia.factura_desde,
        dia.factura_hasta,
        this.formatearMoneda(dia.exentas),
        this.formatearMoneda(dia.gravadas_15),
        this.formatearMoneda(dia.impuesto_15),
        this.formatearMoneda(dia.gravadas_18),
        this.formatearMoneda(dia.impuesto_18),
        this.formatearMoneda(dia.total)
      ]);

      tableData.push([
        { content: 'TOTALES:', styles: { fontStyle: 'bold', fillColor: [240, 240, 240] } },
        { content: '', styles: { fillColor: [240, 240, 240] } },
        { content: '', styles: { fillColor: [240, 240, 240] } },
        { content: this.formatearMoneda(this.totalesFiscales.total_exentas), styles: { fontStyle: 'bold', fillColor: [240, 240, 240], halign: 'right' } },
        { content: this.formatearMoneda(this.totalesFiscales.total_gravadas_15), styles: { fontStyle: 'bold', fillColor: [240, 240, 240], halign: 'right' } },
        { content: this.formatearMoneda(this.totalesFiscales.total_impuesto_15), styles: { fontStyle: 'bold', fillColor: [240, 240, 240], halign: 'right' } },
        { content: this.formatearMoneda(this.totalesFiscales.total_gravadas_18), styles: { fontStyle: 'bold', fillColor: [240, 240, 240], halign: 'right' } },
        { content: this.formatearMoneda(this.totalesFiscales.total_impuesto_18), styles: { fontStyle: 'bold', fillColor: [240, 240, 240], halign: 'right' } },
        { content: this.formatearMoneda(this.totalesFiscales.total_general), styles: { fontStyle: 'bold', fillColor: [240, 240, 240], halign: 'right' } }
      ]);

      doc.autoTable({
        head: fiscalHeaders,
        body: tableData,
        startY: startY,
        styles: {
          fontSize: 7,
          cellPadding: 2,
          lineColor: [200, 200, 200],
          lineWidth: 0.1
        },
        headStyles: {
          fillColor: [0, 0, 0],
          textColor: 255,
          fontStyle: 'bold',
          fontSize: 7,
          halign: 'center'
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245]
        },
        columnStyles: {
          0: { halign: 'center', cellWidth: 22 },
          1: { halign: 'center', cellWidth: 28 },
          2: { halign: 'center', cellWidth: 28 },
          3: { halign: 'right', cellWidth: 22 },
          4: { halign: 'right', cellWidth: 25 },
          5: { halign: 'right', cellWidth: 22 },
          6: { halign: 'right', cellWidth: 25 },
          7: { halign: 'right', cellWidth: 22 },
          8: { halign: 'right', cellWidth: 22 }
        }
      });
      return;
    }
  }

  doc.autoTable({
    head: [headers],
    body: tableData,
    startY: startY,
    styles: {
      fontSize: this.reporteSeleccionado === 'reporte_compras' || this.reporteSeleccionado === 'facturas_sin_sar' ? 6 : 8,
      cellPadding: this.reporteSeleccionado === 'reporte_compras' || this.reporteSeleccionado === 'facturas_sin_sar' ? 1.5 : 2,
    },
    headStyles: {
      fillColor: [0, 0, 0],
      textColor: 255,
      fontStyle: 'bold',
      fontSize: this.reporteSeleccionado === 'reporte_compras' || this.reporteSeleccionado === 'facturas_sin_sar' ? 6 : 8
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245]
    },
    columnStyles: this.reporteSeleccionado === 'reporte_compras' || this.reporteSeleccionado === 'facturas_sin_sar' ? {
      6: { halign: 'right' },
      7: { halign: 'right' },
      8: { halign: 'right' },
      9: { halign: 'right' },
      10: { halign: 'right' }
    } : {}
  });

  // ✅ Agregar resumen para facturas sin SAR
  if (this.reporteSeleccionado === 'facturas_sin_sar') {
    const finalY = doc.lastAutoTable.finalY + 10;
    
    // ⚠️ Advertencia en rojo
    doc.setFillColor(255, 243, 205);
    doc.rect(15, finalY, 180, 20, 'F');
    doc.setDrawColor(255, 193, 7);
    doc.rect(15, finalY, 180, 20, 'S');
    
    doc.setFontSize(10);
    doc.setTextColor(245, 124, 0);
    doc.setFont(undefined, 'bold');
    doc.text(' ATENCIÓN:', 20, finalY + 7);
    
    doc.setFont(undefined, 'normal');
    doc.setTextColor(102, 102, 102);
    doc.text('Estas facturas fueron generadas con numeración temporal cuando el rango SAR estaba vencido.', 20, finalY + 13);
    doc.text('Deben ser refacturadas una vez se active un nuevo rango SAR válido.', 20, finalY + 18);
    
    // Resumen de totales
    const resumenY = finalY + 30;
    doc.setFontSize(12);
    doc.setTextColor(245, 124, 0);
    doc.setFont(undefined, 'bold');
    doc.text('RESUMEN DE FACTURAS SIN SAR:', 15, resumenY);
    
    doc.setFontSize(10);
    doc.setFont(undefined, 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(`Total de Facturas: ${this.totalesFacturasSinSAR.total_facturas}`, 15, resumenY + 7);
    doc.text(`Total Exento: ${this.formatearMoneda(this.totalesFacturasSinSAR.total_extento)}`, 15, resumenY + 12);
    doc.text(`Total Gravado 15%: ${this.formatearMoneda(this.totalesFacturasSinSAR.total_gravado_15)}`, 15, resumenY + 17);
    doc.text(`Total Gravado 18%: ${this.formatearMoneda(this.totalesFacturasSinSAR.total_gravado_18)}`, 15, resumenY + 22);
    doc.text(`Total ISV: ${this.formatearMoneda(this.totalesFacturasSinSAR.total_isv)}`, 15, resumenY + 27);
    
    doc.setFont(undefined, 'bold');
    doc.setTextColor(245, 124, 0);
    doc.text(`TOTAL GENERAL: ${this.formatearMoneda(this.totalesFacturasSinSAR.total_general)}`, 15, resumenY + 37);
  }

  // Resúmenes para otros reportes...
  if (this.reporteSeleccionado === 'ventas_canceladas') {
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    doc.text('RESUMEN DE VENTAS CANCELADAS:', 15, finalY);
    doc.setFontSize(10);
    doc.text(`Total de ventas canceladas: ${this.totalesVentasCanceladas.total_ventas}`, 15, finalY + 5);
    doc.text(`Monto total cancelado: ${this.formatearMoneda(this.totalesVentasCanceladas.total_monto)}`, 15, finalY + 10);
    doc.text(`Exento: ${this.formatearMoneda(this.totalesVentasCanceladas.total_extento)}`, 15, finalY + 15);
    doc.text(`Gravado 15%: ${this.formatearMoneda(this.totalesVentasCanceladas.gravado_15)}`, 15, finalY + 20);
    doc.text(`Gravado 18%: ${this.formatearMoneda(this.totalesVentasCanceladas.gravado_18)}`, 15, finalY + 25);
    doc.text(`ISV: ${this.formatearMoneda(this.totalesVentasCanceladas.total_isv)}`, 15, finalY + 30);
  }

  if (this.reporteSeleccionado === 'reporte_compras') {
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(12);
    doc.text('RESUMEN TOTAL DE COMPRAS:', 15, finalY);
    doc.setFontSize(10);
    doc.text(`Total Gravado 15%: ${this.formatearMoneda(this.totalesCompras.total_gravado_15)}`, 15, finalY + 5);
    doc.text(`Total Exento: ${this.formatearMoneda(this.totalesCompras.total_exento)}`, 15, finalY + 10);
    doc.text(`Total Subtotal: ${this.formatearMoneda(this.totalesCompras.total_subtotal)}`, 15, finalY + 15);
    doc.text(`Total Descuentos: ${this.formatearMoneda(this.totalesCompras.total_descuento)}`, 15, finalY + 20);
    doc.text(`Total Impuesto 15%: ${this.formatearMoneda(this.totalesCompras.total_impuesto_15)}`, 15, finalY + 25);
    doc.setFont(undefined, 'bold');
    doc.text(`TOTAL GENERAL: ${this.formatearMoneda(this.totalesCompras.total_general)}`, 15, finalY + 35);
  }
},

    formatearFecha(fecha) {
      return new Date(fecha).toLocaleDateString("es-HN");
    },

    formatearMoneda(valor) {
      return new Intl.NumberFormat("es-HN", {
        style: "currency",
        currency: "HNL",
      }).format(valor || 0);
    },

    formatearCantidad(cantidad) {
      return new Intl.NumberFormat("es-HN").format(cantidad || 0);
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.processFile(file);
      }
    },

    handleDrop(e) {
      this.isDragging = false;
      const file = e.dataTransfer.files[0];
      if (file) {
        this.processFile(file);
      }
    },

    processFile(file) {
      if (!file.type.match("image/jpeg|image/jpg|image/png|image/webp")) {
        notis('warning', 'Por favor selecciona un archivo JPEG, JPG, PNG o WebP');
        return;
      }
      if (file.size > 40 * 1024 * 1024) {
        notis('warning', 'El archivo debe ser menor a 40 MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.logoUrl = e.target.result;
        localStorage.setItem("logoEmpresa", e.target.result);
      };
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.logoUrl = null;
      localStorage.removeItem("logoEmpresa");
    },

    onDragLeave(e) {
      if (!e.relatedTarget || !this.$el.contains(e.relatedTarget)) {
        this.isDragging = false;
      }
    },

    async openModalHeaderFooter() {
      this.showHeaderFooterModal = true;
    },

    handleHeaderFooterSave(config) {
      this.headerFooterConfig = config;
      this.showHeaderFooterModal = false;
    },

    async exportarExcel() {
  try {
    if (!this.datosReporte || this.datosReporte.length === 0) {
      notis("error", "No hay datos para exportar");
      return;
    }

    const XLSX = await import('xlsx');
    let workbook;
    let worksheetName;

    // ✅ REPORTE FISCAL
    if (this.reporteSeleccionado === 'reporte_fiscal') {
      const excelData = this.datosReporte.map(dia => ({
        'Fecha': this.formatearFecha(dia.fecha),
        'Factura Desde': dia.factura_desde,
        'Factura Hasta': dia.factura_hasta,
        'Exentas': dia.exentas,
        'Gravadas 15%': dia.gravadas_15,
        'Impuesto 15%': dia.impuesto_15,
        'Gravadas 18%': dia.gravadas_18,
        'Impuesto 18%': dia.impuesto_18,
        'Total': dia.total
      }));

      excelData.push({});
      excelData.push({
        'Fecha': 'TOTALES:',
        'Factura Desde': '',
        'Factura Hasta': '',
        'Exentas': this.totalesFiscales.total_exentas,
        'Gravadas 15%': this.totalesFiscales.total_gravadas_15,
        'Impuesto 15%': this.totalesFiscales.total_impuesto_15,
        'Gravadas 18%': this.totalesFiscales.total_gravadas_18,
        'Impuesto 18%': this.totalesFiscales.total_impuesto_18,
        'Total': this.totalesFiscales.total_general
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 15 },  // Fecha
        { wch: 20 },  // Desde
        { wch: 20 },  // Hasta
        { wch: 15 },  // Exentas
        { wch: 18 },  // Gravadas 15%
        { wch: 18 },  // Impuesto 15%
        { wch: 18 },  // Gravadas 18%
        { wch: 18 },  // Impuesto 18%
        { wch: 15 }   // Total
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte Fiscal');
      worksheetName = 'Reporte_Fiscal_Ventas';
    }
    
    // ✅ REPORTE DE COMPRAS
    else if (this.reporteSeleccionado === 'reporte_compras') {
      const excelData = this.datosReporte.map((compra, index) => ({
        'No.': index + 1,
        'Fecha': this.formatearFecha(compra.fecha),
        'Proveedor': compra.proveedor,
        'RTN': compra.rtn,
        'CAI': compra.cai,
        'No. Factura': compra.numero_factura,
        'Gravado 15%': compra.gravado_15,
        'Exento': compra.valor_exento,
        'Subtotal': compra.subtotal,
        'Descuento': compra.descuento,
        'Impuesto 15%': compra.impuesto_15,
        'Total': compra.total,
        'Estado': compra.estado,
        'Sucursal': compra.sucursal
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 5 }, { wch: 12 }, { wch: 25 }, { wch: 18 }, 
        { wch: 20 }, { wch: 18 }, { wch: 15 }, { wch: 15 },
        { wch: 15 }, { wch: 12 }, { wch: 15 }, { wch: 15 },
        { wch: 12 }, { wch: 20 }
      ];

      const lastRow = excelData.length + 2;
      XLSX.utils.sheet_add_aoa(worksheet, [
        ['', '', '', '', '', 'TOTALES:', 
         this.totalesCompras.total_gravado_15,
         this.totalesCompras.total_exento,
         this.totalesCompras.total_subtotal,
         this.totalesCompras.total_descuento,
         this.totalesCompras.total_impuesto_15,
         this.totalesCompras.total_general,
         '', '']
      ], { origin: `A${lastRow}` });

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte de Compras');
      worksheetName = 'Reporte_Compras';
    }
    
    // ✅ REPORTES TRADICIONALES DE VENTAS
    else if (this.isTraditionalSalesReport) {
      const excelData = this.datosAgrupados.map(item => ({
        [this.labelFiltro]: item.nombre,
        'Valor Exento': item.valor_exento || item.valor_extento || 0,
        'Gravado 15%': item.gravado_15 || 0,
        'Gravado 18%': item.gravado_18 || 0,
        'ISV': item.total_isv || 0,
        'Total': item.total || 0
      }));

      if (this.especificacion) {
        this.datosAgrupados.forEach(grupo => {
          if (grupo.desglose && grupo.desglose.length > 0) {
            excelData.push({
              [this.labelFiltro]: `--- Facturas de ${grupo.nombre} ---`,
              'Valor Exento': '', 'Gravado 15%': '', 'Gravado 18%': '',
              'ISV': '', 'Total': ''
            });

            grupo.desglose.forEach(factura => {
              excelData.push({
                [this.labelFiltro]: factura.nombre,
                'Valor Exento': factura.valor_exento || 0,
                'Gravado 15%': factura.gravado_15 || 0,
                'Gravado 18%': factura.gravado_18 || 0,
                'ISV': factura.total_isv || 0,
                'Total': factura.total || 0
              });
            });
          }
        });
      }

      excelData.push({});
      excelData.push({
        [this.labelFiltro]: 'TOTALES:',
        'Valor Exento': this.totales.exento,
        'Gravado 15%': this.totales.gravado_15,
        'Gravado 18%': this.totales.gravado_18,
        'ISV': this.totales.total_isv,
        'Total': this.totales.total
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 30 }, { wch: 15 }, { wch: 15 },
        { wch: 15 }, { wch: 15 }, { wch: 15 }
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte de Ventas');
      worksheetName = 'Reporte_Ventas';
    }
    
    // ✅ PRODUCTOS MÁS VENDIDOS
    else if (this.reporteSeleccionado === 'productos_vendidos') {
      const excelData = this.datosReporte.map((producto, index) => ({
        'Ranking': index + 1,
        'Producto': producto.nombre,
        'Código': producto.codigo,
        'Cantidad Vendida': producto.cantidad_vendida,
        'Total Vendido': producto.total_vendido,
        'Número de Ventas': producto.numero_ventas,
        'Precio Unitario': producto.precio_unitario
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 10 }, { wch: 30 }, { wch: 15 }, { wch: 18 },
        { wch: 18 }, { wch: 18 }, { wch: 18 }
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Productos Vendidos');
      worksheetName = 'Productos_Vendidos';
    }
    
    // ✅ CLIENTES FRECUENTES
    else if (this.reporteSeleccionado === 'clientes_frecuentes') {
      const excelData = this.datosReporte.map((cliente, index) => ({
        'Ranking': index + 1,
        'Cliente': cliente.nombre,
        'Teléfono': cliente.telefono || 'N/A',
        'Correo': cliente.correo || 'N/A',
        'Visitas': cliente.numero_visitas,
        'Monto Total': cliente.monto_total,
        'Promedio por Compra': cliente.promedio_compra,
        'Última Visita': this.formatearFecha(cliente.ultima_visita)
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 10 }, { wch: 30 }, { wch: 15 }, { wch: 25 },
        { wch: 10 }, { wch: 18 }, { wch: 18 }, { wch: 15 }
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Clientes Frecuentes');
      worksheetName = 'Clientes_Frecuentes';
    }
    
    // ✅ VENTAS CANCELADAS
    else if (this.reporteSeleccionado === 'ventas_canceladas') {
      const excelData = this.datosReporte.map(venta => ({
        'Factura': venta.numero_factura,
        'Empleado': venta.empleado,
        'Cliente': venta.cliente,
        'Sucursal': venta.sucursal,
        'Total': venta.total,
        'Fecha Cancelación': this.formatearFecha(venta.fecha_anulacion),
        'Motivo': venta.motivo_cancelacion || 'N/A'
      }));

      excelData.push({});
      excelData.push({
        'Factura': 'RESUMEN:',
        'Empleado': '', 'Cliente': '', 'Sucursal': '',
        'Total': '', 'Fecha Cancelación': '', 'Motivo': ''
      });
      excelData.push({
        'Factura': 'Total Ventas Canceladas:',
        'Empleado': this.totalesVentasCanceladas.total_ventas,
        'Cliente': '', 'Sucursal': '', 'Total': '',
        'Fecha Cancelación': '', 'Motivo': ''
      });
      excelData.push({
        'Factura': 'Monto Total:',
        'Empleado': '', 'Cliente': '', 'Sucursal': '',
        'Total': this.totalesVentasCanceladas.total_monto,
        'Fecha Cancelación': '', 'Motivo': ''
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 20 }, { wch: 25 }, { wch: 25 }, { wch: 20 },
        { wch: 15 }, { wch: 18 }, { wch: 30 }
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Ventas Canceladas');
      worksheetName = 'Ventas_Canceladas';
    }
    
    // ✅ NUEVO: FACTURAS SIN SAR
    else if (this.reporteSeleccionado === 'facturas_sin_sar') {
      // Advertencia en las primeras filas
      const excelData = [
        {},
        {
          'Número Temporal': '⚠️ ATENCIÓN: Estas facturas fueron generadas con numeración temporal cuando el rango SAR estaba vencido.',
          'Fecha': '',
          'Estado': '',
          'Empleado': '',
          'Cliente': '',
          'Sucursal': '',
          'Exento': '',
          'Gravado 15%': '',
          'Gravado 18%': '',
          'ISV': '',
          'Total': ''
        },
        {
          'Número Temporal': 'Deben ser refacturadas una vez se active un nuevo rango SAR válido.',
          'Fecha': '',
          'Estado': '',
          'Empleado': '',
          'Cliente': '',
          'Sucursal': '',
          'Exento': '',
          'Gravado 15%': '',
          'Gravado 18%': '',
          'ISV': '',
          'Total': ''
        },
        {}
      ];

      // Agregar datos de facturas
      this.datosReporte.forEach(factura => {
        excelData.push({
          'Número Temporal': factura.numero_temporal,
          'Fecha': this.formatearFecha(factura.fecha),
          'Estado': factura.estado,
          'Empleado': factura.empleado,
          'Cliente': factura.cliente,
          'Sucursal': factura.sucursal,
          'Exento': factura.total_extento,
          'Gravado 15%': factura.gravado_15,
          'Gravado 18%': factura.gravado_18,
          'ISV': factura.total_isv,
          'Total': factura.total
        });
      });

      // Agregar totales
      excelData.push({});
      excelData.push({
        'Número Temporal': 'RESUMEN:',
        'Fecha': '',
        'Estado': '',
        'Empleado': '',
        'Cliente': '',
        'Sucursal': '',
        'Exento': '',
        'Gravado 15%': '',
        'Gravado 18%': '',
        'ISV': '',
        'Total': ''
      });
      excelData.push({
        'Número Temporal': `Total de Facturas: ${this.totalesFacturasSinSAR.total_facturas}`,
        'Fecha': '',
        'Estado': '',
        'Empleado': '',
        'Cliente': '',
        'Sucursal': '',
        'Exento': this.totalesFacturasSinSAR.total_extento,
        'Gravado 15%': this.totalesFacturasSinSAR.total_gravado_15,
        'Gravado 18%': this.totalesFacturasSinSAR.total_gravado_18,
        'ISV': this.totalesFacturasSinSAR.total_isv,
        'Total': this.totalesFacturasSinSAR.total_general
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 25 }, // Número Temporal
        { wch: 12 }, // Fecha
        { wch: 10 }, // Estado
        { wch: 25 }, // Empleado
        { wch: 25 }, // Cliente
        { wch: 20 }, // Sucursal
        { wch: 15 }, // Exento
        { wch: 15 }, // Gravado 15%
        { wch: 15 }, // Gravado 18%
        { wch: 15 }, // ISV
        { wch: 15 }  // Total
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Facturas Sin SAR');
      worksheetName = 'Facturas_Sin_SAR';
    }
    
    // ✅ ROTACIÓN DE INVENTARIO
    else if (this.reporteSeleccionado === 'rotacion_inventario') {
      const excelData = this.datosReporte.map(item => ({
        'Producto': item.producto,
        'Sucursal': item.categoria || '—',
        'Stock Actual': item.stock_actual,
        'Precio Venta': item.precio_venta,
        'Valor Inventario': item.valor_inventario,
        'Días sin Ventas': item.dias_sin_ventas ?? '—'
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 35 }, { wch: 20 }, { wch: 14 },
        { wch: 16 }, { wch: 18 }, { wch: 16 }
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Rotación Inventario');
      worksheetName = 'Rotacion_Inventario';
    }

    // ✅ COMPARATIVO MENSUAL
    else if (this.reporteSeleccionado === 'comparativo_mensual') {
      const excelData = this.datosReporte.map(m => ({
        'Mes': m.mes_nombre,
        'Total Ventas': m.total_ventas,
        'Transacciones': m.total_transacciones,
        'Promedio por Venta': m.ticket_promedio
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 20 }, { wch: 18 }, { wch: 16 }, { wch: 18 }
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Comparativo Mensual');
      worksheetName = 'Comparativo_Mensual';
    }

    // ✅ ÓRDENES DE PRODUCCIÓN
    else if (this.reporteSeleccionado === 'ordenes_produccion') {
      const excelData = this.datosReporte.map((o, i) => ({
        'No.':           i + 1,
        'Fecha':         this.formatearFecha(o.fecha),
        'Receta':        o.receta,
        'Producto':      o.producto,
        'Cantidad':      o.cantidad,
        'Estado':        o.estado,
        'Costo Total':   o.costo_total,
        'Costo/Unidad':  o.costo_por_unidad,
        'Precio Actual': o.precio_actual,
        'Margen %':      o.margen_pct,
        'Usuario':       o.usuario,
        'Sucursal':      o.sucursal,
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 5 }, { wch: 12 }, { wch: 25 }, { wch: 25 }, { wch: 10 },
        { wch: 12 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 10 },
        { wch: 22 }, { wch: 22 },
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Órdenes Producción');
      worksheetName = 'Ordenes_Produccion';
    }

    // ✅ RENDIMIENTO POR RECETA
    else if (this.reporteSeleccionado === 'margen_produccion') {
      const excelData = this.datosReporte.map(r => ({
        'Receta':          r.receta,
        'Producto':        r.producto,
        'Órdenes':         r.ordenes,
        'Uds. Producidas': r.total_unidades,
        'Costo Total':     r.costo_total,
        'Costo/Unidad':    r.costo_por_unidad,
        'Precio Actual':   r.precio_actual,
        'Margen %':        r.margen_pct,
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!cols'] = [
        { wch: 25 }, { wch: 25 }, { wch: 10 }, { wch: 16 },
        { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 10 },
      ];

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Rendimiento Recetas');
      worksheetName = 'Margen_Produccion';
    }

    // ✅ NO DISPONIBLE
    else {
      notis("info", "Exportación a Excel no disponible para este tipo de reporte");
      return;
    }

    const fechaArchivo = new Date().toISOString().split('T')[0];
    const nombreArchivo = `${worksheetName}_${fechaArchivo}.xlsx`;
    
    XLSX.writeFile(workbook, nombreArchivo);
    
    notis("success", "Archivo Excel generado exitosamente");

  } catch (error) {
    console.error("Error generando Excel:", error);
    notis("error", "Error al generar el archivo Excel: " + error.message);
  }
}
  },

  async mounted() {
    setPageTitle("Reportería Avanzada");
    this.isLoading = true;
    try {
      const savedLogo = localStorage.getItem("logoEmpresa");
      if (savedLogo) {
        this.logoUrl = savedLogo;
      }

      this.id_usuario = await solicitudes.solicitarUsuarioToken();
      this.esCeo = await esCeo(this.id_usuario);

      await this.cargarDatos();

      try {
        const response = await getDatosInstitucion(this.id_usuario, this.esCeo);
        this.datosBussines = response;

        this.headerFooterConfig.header.companyName = this.datosBussines.nombre;
        this.headerFooterConfig.header.address = this.datosBussines.direccion;
        this.headerFooterConfig.header.phone = this.datosBussines.telefono;
        this.headerFooterConfig.header.email = this.datosBussines.correo;
      } catch (error) {
        console.error("❌ Error al cargar datos de empresa:", error);
        notis("error", "Error al cargar datos de empresa");
      }
    } catch (error) {
      console.error("❌ Error al inicializar:", error);
      notis("error", "Error al cargar datos iniciales");
    } finally {
      this.isLoading = false;
    }
    const _s = getSocket();
    if (_s) { this._wsRefresh = () => { if (this.id_usuario) this.cargarDatos(); }; _s.on('ventas:refresh', this._wsRefresh); }
  },

  watch: {
    async reporteSeleccionado(newValue) {
      if (newValue === 'ventas_sucursal' && !this.esCeo) {
        this.reporteSeleccionado = 'ventas_cliente';
        notis("warning", "Solo los CEOs pueden acceder al reporte de ventas por sucursal");
        return;
      }
      
      this.valorFiltro = "";
      this.valorFiltroTexto = "";
      this.especificacion = false;
      this.resetearEstado();
      
      if ((newValue === 'ventas_cliente' && this.clientes.length === 0) ||
          (newValue === 'ventas_empleado' && this.empleados.length === 0) ||
          (newValue === 'ventas_sucursal' && this.sucursales.length === 0)) {
        await this.cargarDatos();
      }
    },

    "filtros.fechaInicio"() {
      this.resetearEstado();
    },

    "filtros.fechaFin"() {
      this.resetearEstado();
    },

    valorFiltro() {
      this.resetearEstado();
    },

    especificacion: {
      immediate: true,
      async handler(newValue) {
        if (newValue && this.fechasValidas && this.datosReporte.length > 0 && this.isTraditionalSalesReport) {
          this.isLoading = true;
          try {
            await this.mostrarReportesVentas();
          } catch (error) {
            console.error("Error al actualizar especificación:", error);
            notis("error", "Error al cargar los detalles");
          } finally {
            this.isLoading = false;
          }
        }
      },
    },
  },

  beforeUnmount() {
    this.destroyCharts();
    const _s = getSocket();
    if (_s && this._wsRefresh) _s.off('ventas:refresh', this._wsRefresh);
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

/* Fuentes */
* {
  font-family: "Montserrat", sans-serif;
  box-sizing: border-box;
}

/* ===============================================
   ESTILOS PARA REPORTE DE COMPRAS
=============================================== */

.compras-container {
  margin-top: 2rem;
}

.numero-row {
  text-align: center;
  font-weight: 600;
  color: #6c757d;
  font-size: 0.875rem;
}

.fecha-compra {
  font-size: 0.875rem;
  color: #495057;
  white-space: nowrap;
}

.proveedor-nombre {
  font-weight: 600;
  color: #28a745;
}

.rtn-proveedor,
.cai-factura,
.numero-factura-compra {
  font-family: 'Courier New', monospace;
  font-size: 0.8rem;
  color: #6c757d;
}

.gravado,
.exento,
.subtotal,
.descuento,
.impuesto {
  text-align: right;
  font-weight: 600;
  font-size: 0.9rem;
}

.total-compra {
  text-align: right;
  font-weight: bold;
  color: #007bff;
  font-size: 1rem;
}

.resumen-compras {
  margin-top: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.resumen-compras .resumen-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #2e7d32;
  text-align: center;
  text-transform: uppercase;
}

.resumen-compras .resumen-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.resumen-compras .resumen-item {
  padding: 1rem;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.resumen-compras .resumen-item.total-general {
  grid-column: span 2;
  background: linear-gradient(135deg, #4caf50, #388e3c);
  color: white;
  padding: 1.5rem;
  border-radius: 8px;
}

.resumen-compras .resumen-item.total-general .resumen-label,
.resumen-compras .resumen-item.total-general .resumen-valor {
  color: white;
  font-size: 1.3rem;
}

/* ===============================================
   ✅ ESTILOS PARA REPORTE FISCAL DE VENTAS
=============================================== */

.fiscal-container {
  margin-top: 2rem;
}

.fiscal-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: none;
}

/* ✅ CAMBIADO A NEGRO */
.fiscal-table thead {
  background: #000000;
}

.fiscal-main-header th {
  color: white;
  font-weight: 600;
  padding: 1rem 0.75rem;
  text-align: center;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

/* ✅ CAMBIADO A GRIS OSCURO */
.fiscal-sub-header th {
  background: #333333;
  color: white;
  font-weight: 600;
  padding: 0.75rem;
  text-align: center;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.fiscal-table tbody tr {
  border-bottom: 1px solid #eee;
}

.fiscal-table tbody tr:last-child {
  border-bottom: none;
}

.fiscal-table tbody tr:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}

.fiscal-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.fiscal-table tbody tr:nth-child(even):hover {
  background-color: #f0f0f0;
}

.fiscal-table td {
  padding: 0.75rem;
  vertical-align: middle;
}

.fecha-fiscal {
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
  white-space: nowrap;
  font-size: 0.95rem;
}

.factura-desde,
.factura-hasta {
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  text-align: center;
  color: #495057;
  font-weight: 500;
}

.exentas {
  text-align: right;
  font-weight: 600;
  color: #6c757d;
  font-size: 0.95rem;
}

.gravadas {
  text-align: right;
  font-weight: 600;
  color: #28a745;
  font-size: 0.95rem;
}

.impuesto {
  text-align: right;
  font-weight: 600;
  color: #fd7e14;
  font-size: 0.95rem;
}

.total-fiscal {
  text-align: right;
  font-weight: bold;
  color: #007bff;
  font-size: 1.05rem;
}

.resumen-fiscal {
  margin-top: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #e8f4f8, #d0e8f2);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.resumen-fiscal .resumen-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1e3c72;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.resumen-grid-fiscal {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.resumen-fiscal .resumen-item {
  padding: 1rem;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #d0e8f2;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.resumen-fiscal .resumen-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 60, 114, 0.15);
}

.resumen-fiscal .resumen-item.total-general {
  grid-column: span 2;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.resumen-fiscal .resumen-item.total-general:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
}

.resumen-fiscal .resumen-item .resumen-label {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.resumen-fiscal .resumen-item .resumen-valor {
  font-size: 1.2rem;
  font-weight: 600;
  color: #212529;
}

.resumen-fiscal .resumen-item.total-general .resumen-label,
.resumen-fiscal .resumen-item.total-general .resumen-valor {
  color: white;
  font-size: 1.3rem;
}

/* ===============================================
   ESTILOS PARA DESGLOSE DE FACTURAS
=============================================== */

.desglose-header {
  background-color: #e8f4fd;
  border-top: 2px solid #007bff;
}

.desglose-header th {
  background-color: #e8f4fd;
  color: #007bff;
  font-weight: 600;
  padding: 8px;
  text-align: left;
  font-size: 0.9rem;
  border-bottom: 1px solid #007bff;
}

.desglose-title {
  text-align: center;
  font-weight: bold;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  padding: 12px;
  font-size: 1rem;
}

.desglose-icon {
  margin-right: 8px;
  font-size: 1.1rem;
}

.numero-factura {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #495057;
  padding-left: 24px;
  position: relative;
}

.factura-icon {
  margin-right: 8px;
  font-size: 1rem;
}

.desglose-table {
  margin-top: 0;
  border-left: 3px solid #007bff;
  background-color: #f8f9fa;
}

.desglose-table .detail-row {
  background-color: #ffffff;
}

.desglose-table .detail-row:hover {
  background-color: #e3f2fd;
}

.desglose-table .detail-row:nth-child(even) {
  background-color: #fafafa;
}

.desglose-table .detail-row:nth-child(even):hover {
  background-color: #e3f2fd;
}

/* ===============================================
   ESTILOS PARA VENTAS CANCELADAS
=============================================== */

.ventas-canceladas-container {
  margin-top: 2rem;
}

.ventas-canceladas-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmin(250px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-label {
  font-weight: 600;
  color: #856404;
}

.summary-value {
  font-weight: bold;
  color: #856404;
  font-size: 1.1rem;
}

.monto-cancelado {
  color: #dc3545;
  font-weight: 600;
}

.desglose-canceladas {
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.desglose-canceladas h4 {
  margin: 0 0 1rem 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 600;
}

.desglose-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}

.desglose-item {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.desglose-label {
  color: #6c757d;
  font-size: 0.9rem;
}

.desglose-valor {
  font-weight: 600;
  color: #495057;
}

/* ===============================================
   ESTILOS PARA EL MODAL DE VENTAS ANULADAS
=============================================== */

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1000px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.modal-header h3 {
  margin: 0;
  color: #495057;
  font-size: 1.25rem;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6c757d;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.modal-close:hover {
  background-color: #e9ecef;
  color: #495057;
}

.modal-body {
  padding: 1.5rem;
  max-height: 60vh;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.loading-message {
  text-align: center;
  padding: 2rem;
  color: #6c757d;
  font-style: italic;
}

.desglose-anuladas {
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.desglose-anuladas h4 {
  margin: 0 0 1rem 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 600;
}

.monto-anulado {
  color: #dc3545;
  font-weight: 600;
}

.ventas-anuladas-section {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
}

.ventas-anuladas-btn {
  background-color: #ffc107;
  color: #212529;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s;
  width: 100%;
}

.ventas-anuladas-btn:hover {
  background-color: #e0a800;
  transform: translateY(-1px);
}

.ventas-anuladas-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.secondary-btn {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.secondary-btn:hover {
  background-color: #5a6268;
}

/* ===============================================
   ESTILOS GENERALES
=============================================== */

.main-content {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin: 2rem 0;
  min-height: 300px;
  width: 100%;
}

.filters-section,
.controls-section {
  width: 45%;
}

.report-container {
  background-color: #f5f5f5;
  color: #000;
  padding: 2rem;
  border-radius: 0;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
}

.report-header {
  width: 100%;
  padding: 20px 0;
  flex-direction: column;
  align-items: center;
}

.report-title {
  font-size: 24px;
  margin: 0;
  margin-left: 20px;
}

.input-group {
  display: flex;
  flex-wrap: wrap;
  gap: clamp(10px, 2vw, 20px);
  margin-top: 5%;
  margin-bottom: clamp(1rem, 3vw, 2rem);
}

.input-field {
  flex: 1 1 calc(50% - 10px);
  min-width: 250px;
}

.fecha,
input[type="date"],
input[list],
select {
  width: 100%;
  padding: clamp(6px, 1.5vw, 8px);
  border: 1px solid #444;
  border-radius: 4px;
  background-color: #f5f5f5;
  color: #000;
  font-size: clamp(0.875rem, 1.5vw, 1rem);
}

label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  color: #000;
  font-size: clamp(0.875rem, 1.5vw, 1rem);
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: clamp(5px, 1.5vw, 10px);
  margin-top: clamp(1rem, 3vw, 1.5rem);
  margin-bottom: clamp(0.5rem, 2vw, 1rem);
}

.header-footer-btn {
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.header-footer-btn:hover {
  background-color: #545b62;
}

.btn {
  padding: clamp(8px, 1.5vw, 10px) clamp(15px, 2vw, 20px);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  font-size: clamp(0.875rem, 1.5vw, 1rem);
  transition: opacity 0.3s ease;
  flex: 1;
  min-width: 120px;
  max-width: 200px;
}

.btn:hover {
  opacity: 0.9;
}

.pdf-btn {
  background-color: #198754;
  color: #fff;
}
.pdf-btn:hover:not(:disabled) { background-color: #146c43; }

.excel-btn {
  background-color: #198754;
  color: #fff;
}
.excel-btn:hover:not(:disabled) { background-color: #146c43; }

.generate-btn {
  background-color: #c09d62;
  color: #fff;
}
.generate-btn:hover:not(:disabled) { background-color: #a38655; }

.table-header {
  height: clamp(35px, 5vw, 40px);
  background-color: #00a3ff;
  border-radius: 4px 4px 0 0;
}

.table-container {
  width: 100%;
  overflow-x: auto;
  margin-top: clamp(0.5rem, 2vw, 1rem);
}

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  min-width: 600px;
}

thead th {
  text-align: left;
  padding: clamp(6px, 1.5vw, 8px);
  background-color: #f5f5f5;
  color: #000;
  font-weight: bold;
  font-size: clamp(0.875rem, 1.5vw, 1rem);
  white-space: nowrap;
}

tbody td {
  padding: clamp(6px, 1.5vw, 8px);
  border-top: 1px solid #333;
  color: #000;
  font-size: clamp(0.875rem, 1.5vw, 1rem);
}

.totals {
  margin-top: clamp(1rem, 3vw, 1.5rem);
  display: flex;
  flex-wrap: wrap;
  gap: clamp(10px, 2vw, 20px);
  justify-content: space-between;
}

.totals div {
  flex: 1 1 calc(50% - 10px);
  min-width: 250px;
  color: #000;
  font-size: clamp(0.875rem, 1.5vw, 1rem);
}

.report-wrapper {
  padding: 16px;
  width: 100%;
  overflow-x: hidden;
}

.report-body {
  margin-top: 2rem;
}

.date-buttons {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.date-btn {
  padding: 0.5rem 1rem;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.3s;
  flex: 1;
  min-width: 80px;
}

.date-btn:hover {
  background-color: #5a6268;
}

.additional-filters {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.filter-checkbox {
  margin-bottom: 1rem;
}

/* ✅ TABLAS MODERNAS - HEADERS NEGROS */
.modern-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: none;
}

.modern-table th {
  background: #000000;
  color: white;
  font-weight: 600;
  padding: 1rem 0.75rem;
  text-align: left;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modern-table td {
  padding: 0.75rem;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
}

.modern-table tr:last-child td {
  border-bottom: none;
}

.modern-table tr:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}

.modern-table tr:nth-child(even) {
  background-color: #fafafa;
}

.modern-table tr:nth-child(even):hover {
  background-color: #f0f0f0;
}

/* Estilos para productos vendidos */
.productos-vendidos-container {
  margin-top: 2rem;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.rank {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: bold;
  min-width: 24px;
  text-align: center;
}

.cantidad, .numero {
  font-weight: 600;
  color: #28a745;
  font-size: 1rem;
}

.monto, .precio {
  font-weight: 600;
  color: #007bff;
  font-size: 1rem;
}

/* Estilos para clientes frecuentes */
.clientes-frecuentes-container {
  margin-top: 2rem;
}

.client-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.contact-info {
  font-size: 0.875rem;
  color: #6c757d;
  line-height: 1.3;
}

.contact-info div {
  margin-bottom: 0.25rem;
}

.visits {
  font-weight: 600;
  color: #fd7e14;
  font-size: 1.1rem;
}

.amount, .average {
  font-weight: 600;
  color: #28a745;
  font-size: 1rem;
}

.date {
  color: #6c757d;
  font-size: 0.875rem;
  font-style: italic;
}

/* Estilos para inventario bajo stock */
.inventario-bajo-container {
  margin-top: 2rem;
}

.product-detail {
  line-height: 1.4;
}

.product-detail strong {
  display: block;
  color: #333;
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}

.product-detail small {
  color: #6c757d;
  font-size: 0.8rem;
  font-style: italic;
}

.stock-actual {
  font-weight: bold;
  color: #ffc107;
  font-size: 1.1rem;
  text-align: center;
}

.stock-actual.sin-stock {
  color: #dc3545;
  background-color: #f8d7da;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}

.stock-min {
  color: #6c757d;
  text-align: center;
}

.diferencia {
  font-weight: bold;
  color: #dc3545;
  text-align: center;
  font-size: 1rem;
}

.status-badge {
  padding: 0.4rem 0.8rem;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  display: inline-block;
  min-width: 80px;
}

.status-badge.sin-stock {
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
}

.status-badge.stock-bajo {
  background: linear-gradient(135deg, #ffc107, #e0a800);
  color: #212529;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);
}

/* Estilos para gráficos */
.chart-container {
  margin: 2rem 0;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.chart-container canvas {
  max-height: 400px;
}

/* Estilos para ventas por hora */
.ventas-hora-container {
  margin-top: 2rem;
}

.hora {
  font-weight: 600;
  color: #495057;
  font-size: 1rem;
  text-align: center;
}

.total {
  font-weight: 600;
  color: #007bff;
  text-align: right;
}

.promedio {
  color: #6c757d;
  text-align: right;
  font-style: italic;
}

/* Estilos para métodos de pago */
.metodos-pago-container {
  margin-top: 2rem;
}

.metodo {
  font-weight: 600;
  color: #495057;
  font-size: 1rem;
}

.transacciones {
  font-weight: 600;
  color: #fd7e14;
  text-align: center;
  font-size: 1rem;
}

.percentage-bar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
}

.bar {
  height: 24px;
  background: linear-gradient(90deg, #28a745, #20c997);
  border-radius: 12px;
  min-width: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
  flex: 1;
  max-width: 200px;
}

.percentage-bar span {
  font-weight: 600;
  color: #495057;
  min-width: 45px;
  text-align: right;
}

/* Alertas mejoradas */
.error-message {
  margin: 1rem 0;
}

.alert-message {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.95rem;
  color: #6c757d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin: 1rem 0;
}

.alert-message.error {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.alert-icon {
  font-size: 1.3rem;
  flex-shrink: 0;
}

.no-data-message {
  display: flex;
  justify-content: center;
  padding: 2rem;
}

/* Estilos existentes del componente original */
.filters-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 45%;
}

.filter-row {
  display: flex;
  gap: 2rem;
}

.filter-group {
  flex: 1;
}

.date-group {
  width: 100%;
}

.date-field {
  flex: 1;
}

.date-inputs {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
}

.select-input,
input[type="date"] {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Botones deshabilitados */
.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Checkbox styles */
.checkbox-container {
  margin-bottom: 1rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  width: fit-content;
}

.checkbox-input {
  cursor: pointer;
  margin: 0;
}

.checkbox-text {
  user-select: none;
}

/* Estilos para upload de imagen */
.controls-section {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.image-upload-wrapper {
  height: 100%;
  margin-top: 2rem;
}

.image-drop-area {
  height: 100%;
  min-height: 200px;
  padding: 1rem;
  border: 2px dashed #ccc;
  position: relative;
  display: flex;
  align-items: top;
  justify-content: center;
  border-radius: 8px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.image-drop-area:hover {
  border-color: #4a90e2;
  background: #f0f4f8;
}

.drag-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(74, 144, 226, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 8px;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
  margin-top: 2rem;
}

.upload-icon {
  color: #666;
}

.upload-button {
  background-color: #4a90e2;
  color: white;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;
}

.upload-button:hover {
  background-color: #357abd;
}

.upload-info {
  color: #666;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}

.separator {
  margin: 0.25rem 0;
  color: #666;
}

.preview-content {
  position: relative;
}

.preview-image {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  align-items: center;
}

.image-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
}

.remove-button,
.change-button {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.3s;
}

.remove-button {
  background-color: #dc3545;
  color: white;
}

.change-button {
  background-color: #4a90e2;
  color: white;
}

.remove-button:hover {
  background-color: #c82333;
}

.change-button:hover {
  background-color: #357abd;
}

.hidden-input {
  display: none;
}

/* Estilos para tablas tradicionales */
.group-header {
  background-color: #f5f5f5;
  font-weight: bold;
}

.detail-row {
  background-color: #ffffff;
}

/* Contenedor principal de tablas */
.tablas-container {
  width: 100%;
  border: 1px solid #ddd;
}

/* ✅ Estilos para tabla sin especificación - HEADER NEGRO */
.table-no-spec {
  margin-bottom: 2rem;
}

.table-no-spec thead th {
  background-color: #000000;
  color: white;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 8px;
}

.table-no-spec tr {
  border-bottom: 1px solid #ddd;
}

.table-no-spec tr:last-child {
  border-bottom: none;
}

/* ✅ Headers de tabla - NEGRO */
.table-headers {
  border-bottom: 2px solid #ddd;
  table-layout: fixed;
}

.table-headers th {
  position: sticky;
  top: 0;
  background-color: #000000;
  color: white;
  z-index: 1;
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table-headers th:nth-child(1),
.table-content td:nth-child(1) {
  width: 25%;
  min-width: 200px;
}

.table-headers th:nth-child(2),
.table-content td:nth-child(2),
.table-headers th:nth-child(3),
.table-content td:nth-child(3),
.table-headers th:nth-child(4),
.table-content td:nth-child(4) {
  width: 18%;
  min-width: 150px;
}

.table-headers th:nth-child(5),
.table-content td:nth-child(5) {
  width: 12%;
  min-width: 100px;
}

.table-headers th:nth-child(6),
.table-content td:nth-child(6) {
  width: 12%;
  min-width: 100px;
}

/* Contenido de tabla */
.table-content {
  border: none;
  margin: 0;
}

.table-content td {
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

/* Eliminar espacios y bordes duplicados */
.table-content + .table-content {
  border-top: none;
}

/* Estilos para el resumen de totales */
.resumen-totales {
  margin-top: 2rem;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.resumen-titulo {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #dee2e6;
}

.resumen-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}

.resumen-item {
  padding: 1rem;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.resumen-label {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.resumen-valor {
  font-size: 1.2rem;
  font-weight: 600;
  color: #212529;
}

/* ===============================================
   MODO OSCURO
=============================================== */

/* Modo oscuro para compras */
.dark .compras-container {
  color: #fff;
}

.dark .proveedor-nombre {
  color: #4caf50;
}

.dark .rtn-proveedor,
.dark .cai-factura,
.dark .numero-factura-compra {
  color: #adb5bd;
}

.dark .total-compra {
  color: #4a90e2;
}

.dark .resumen-compras {
  background: linear-gradient(135deg, #1e3a1e, #2d4a2d);
}

.dark .resumen-compras .resumen-titulo {
  color: #81c784;
}

.dark .resumen-compras .resumen-item {
  background-color: #2d2d2d;
  border-color: #404040;
}

.dark .resumen-compras .resumen-item.total-general {
  background: linear-gradient(135deg, #388e3c, #2e7d32);
}

/* ✅ Modo oscuro para reporte fiscal */
.dark .fiscal-container {
  color: #fff;
}

.dark .fiscal-table {
  background: #2d2d2d;
}

.dark .fiscal-table thead {
  background: linear-gradient(135deg, #1a2a3a 0%, #2d4a5a 100%);
}

.dark .fiscal-main-header th {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.dark .fiscal-sub-header th {
  background: linear-gradient(135deg, #2d4a5a 0%, #3d6a8a 100%);
}

.dark .fiscal-table tbody tr {
  border-bottom-color: #404040;
}

.dark .fiscal-table tbody tr:hover {
  background-color: #404040;
}

.dark .fiscal-table tbody tr:nth-child(even) {
  background-color: #333;
}

.dark .fiscal-table tbody tr:nth-child(even):hover {
  background-color: #404040;
}

.dark .fecha-fiscal {
  color: #fff;
}

.dark .factura-desde,
.dark .factura-hasta {
  color: #adb5bd;
}

.dark .exentas {
  color: #adb5bd;
}

.dark .gravadas {
  color: #4caf50;
}

.dark .impuesto {
  color: #ff9800;
}

.dark .total-fiscal {
  color: #4a90e2;
}

.dark .resumen-fiscal {
  background: linear-gradient(135deg, #1a2332, #2d3e50);
}

.dark .resumen-fiscal .resumen-titulo {
  color: #4a90e2;
}

.dark .resumen-fiscal .resumen-item {
  background-color: #2d2d2d;
  border-color: #404040;
}

.dark .resumen-fiscal .resumen-item .resumen-label {
  color: #adb5bd;
}

.dark .resumen-fiscal .resumen-item .resumen-valor {
  color: #fff;
}

.dark .resumen-fiscal .resumen-item.total-general {
  background: linear-gradient(135deg, #0056b3, #003d82);
}

/* Modo oscuro para desglose */
.dark .desglose-header {
  background-color: #1a365d;
  border-top-color: #4a90e2;
}

.dark .desglose-header th {
  background-color: #1a365d;
  color: #4a90e2;
  border-bottom-color: #4a90e2;
}

.dark .desglose-title {
  background: linear-gradient(135deg, #4a90e2, #357abd);
}

.dark .numero-factura {
  color: #fff;
}

.dark .desglose-table {
  border-left-color: #4a90e2;
  background-color: #1e1e1e;
}

.dark .desglose-table .detail-row {
  background-color: #2d2d2d;
}

.dark .desglose-table .detail-row:hover {
  background-color: #404040;
}

.dark .desglose-table .detail-row:nth-child(even) {
  background-color: #1a1a1a;
}

.dark .desglose-table .detail-row:nth-child(even):hover {
  background-color: #404040;
}

/* Modo oscuro para ventas canceladas */
.dark .ventas-canceladas-container {
  color: #fff;
}

.dark .ventas-canceladas-summary {
  background-color: #3d3d00;
  border-color: #666600;
}

.dark .summary-label,
.dark .summary-value {
  color: #ffeb3b;
}

.dark .desglose-canceladas {
  background-color: #1e1e1e;
}

.dark .desglose-canceladas h4 {
  color: #fff;
}

.dark .desglose-item {
  background-color: #2d2d2d;
  border-color: #404040;
}

.dark .desglose-label {
  color: #adb5bd;
}

.dark .desglose-valor {
  color: #fff;
}

/* Modo oscuro para modal */
.dark .modal-container {
  background: #2d2d2d;
  color: #fff;
}

.dark .modal-header,
.dark .modal-footer {
  background-color: #1e1e1e;
  border-color: #404040;
}

.dark .modal-header h3 {
  color: #fff;
}

.dark .modal-close {
  color: #adb5bd;
}

.dark .modal-close:hover {
  background-color: #404040;
  color: #fff;
}

/* Botones en modo oscuro */
.dark .date-btn {
  background-color: #495057;
}

.dark .date-btn:hover {
  background-color: #6c757d;
}

.dark .header-footer-btn {
  background-color: #5a6268;
}
.dark .header-footer-btn:hover {
  background-color: #6c757d;
}
.dark .pdf-btn {
  background-color: #198754;
  color: #fff;
}
.dark .excel-btn {
  background-color: #198754;
  color: #fff;
}
.dark .generate-btn {
  background-color: #c09d62;
  color: #fff;
}

/* Inputs y selects en modo oscuro */
.dark .fecha,
.dark input[type="date"],
.dark input[list],
.dark select,
.dark .select-input {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #fff;
}

.dark input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

.dark label {
  color: #fff;
}

/* Tablas modernas en modo oscuro */
.dark .modern-table {
  background: #2d2d2d;
  color: #fff;
}

.dark .modern-table th {
  background: linear-gradient(135deg, #495057 0%, #343a40 100%);
}

.dark .modern-table td {
  border-bottom-color: #404040;
}

.dark .modern-table tr:hover {
  background-color: #404040;
}

.dark .modern-table tr:nth-child(even) {
  background-color: #333;
}

.dark .modern-table tr:nth-child(even):hover {
  background-color: #404040;
}

/* Tablas tradicionales en modo oscuro */
.dark table {
  border-color: #404040;
}

.dark thead th {
  background-color: #383838;
  color: #fff;
  border-color: #404040;
}

.dark tbody td {
  border-color: #404040;
  color: #fff;
}

/* ── Dark mode: Rotación de Inventario ── */
.dark .row-alerta td { background: #3a1f1f !important; }

.dark .badge-amp-success { background: #0f3d22; color: #6ee7a0; }
.dark .badge-amp-warning { background: #3d2e00; color: #fde68a; }
.dark .badge-amp-danger  { background: #3d0f13; color: #fca5a5; }
.dark .badge-amp-info    { background: #0c2a33; color: #67e8f9; }

.dark .amp-info-box {
  background: #1a2e3a;
  border-color: #2d5a70;
  color: #93c5fd;
}

.dark .amp-fila-total { background: #1e2435 !important; border-top-color: #4a5568; }
.dark .amp-fila-total td { color: #e0d8cc !important; }

/* ── Dark mode: Comparativo mensual ── */
.dark .amp-mes-card {
  background: #252535;
  border-color: #3a3a4a;
}
.dark .amp-mes-nombre { color: #e0d8cc; }
.dark .amp-mes-stat span { color: #a09880; }
.dark .amp-mes-stat strong { color: #f0e8d8; }

.dark .group-header {
  background-color: #2a2a2a;
}

.dark .detail-row {
  background-color: #1e1e1e;
}

.dark .table-headers th {
  background-color: #2d2d2d;
  border-color: #404040;
}

.dark .table-content td,
.dark .table-no-spec tr {
  border-color: #404040;
}

.dark .table-no-spec thead th {
  background-color: #383838;
}

/* Gráficos en modo oscuro */
.dark .chart-container {
  background: #2d2d2d;
  color: #fff;
  border-color: #404040;
}

/* Upload de imagen en modo oscuro */
.dark .image-drop-area {
  background: #2d2d2d;
  border-color: #404040;
}

/* Utilidad Bruta — cards y highlight en dark mode */
.dark .amp-card-tot {
  background: #252535;
  border-color: #3a3a4a;
}
.dark .amp-card-tot span { color: #a0a0b0; }
.dark .amp-card-tot strong { color: #e0d8cc; }
.dark .amp-highlight { background: #2a2418; border-color: #c09d62; }
.dark .amp-highlight strong { color: #c09d62; }
.dark .amp-highlight-green { background: #0f2a1a; border-color: #28a745; }
.dark .amp-highlight-green strong { color: #6ee7a0; }
.dark .amp-highlight-yellow { background: #2a2200; border-color: #ffc107; }
.dark .amp-highlight-yellow strong { color: #fde68a; }
.dark .amp-highlight-red { background: #2a0f13; border-color: #dc3545; }
.dark .amp-highlight-red strong { color: #fca5a5; }

/* table-no-spec filas de datos (ventas_cliente / ventas_empleado) */
.dark .table-no-spec tbody tr { background-color: #252535; color: #e0d8cc; }
.dark .table-no-spec tbody tr:nth-child(even) { background-color: #2d2d3d; }
.dark .table-no-spec tbody tr:hover { background-color: #363646; }
.dark .table-no-spec tbody td { color: #e0d8cc; }

.dark .upload-icon,
.dark .separator,
.dark .upload-info {
  color: #999;
}

.dark .upload-button {
  background-color: #004c77;
}

/* Filtros adicionales en modo oscuro */
.dark .additional-filters {
  border-top-color: #404040;
}

/* Alertas en modo oscuro */
.dark .alert-message {
  background-color: #2d2d2d;
  border-color: #404040;
  color: #adb5bd;
}

.dark .alert-message.error {
  background-color: #422a2a;
  border-color: #5a3a3a;
  color: #f5c6cb;
}

/* Resumen de totales en modo oscuro */
.dark .resumen-totales {
  background-color: #2d2d2d;
  border: 1px solid #404040;
}

.dark .resumen-titulo {
  border-bottom-color: #404040;
  color: #fff;
}

.dark .resumen-item {
  background-color: #1e1e1e;
  border-color: #404040;
}

.dark .resumen-label {
  color: #adb5bd;
}

.dark .resumen-valor {
  color: #fff;
}

/* ===============================================
   RESPONSIVE DESIGN
=============================================== */

/* Large Desktop (1440px and up) */
@media screen and (min-width: 1440px) {
  .report-wrapper {
    max-width: 1400px;
    margin: 0 auto;
  }

  .filters-section,
  .controls-section {
    width: 48%;
  }

  .table-container {
    overflow-x: hidden;
  }
}

/* Desktop (1200px and down) */
@media screen and (max-width: 1200px) {
  .filters-section,
  .controls-section {
    width: 47%;
  }

  .button-group {
    justify-content: flex-start;
  }

  .btn {
    min-width: 100px;
  }
}

/* Tablet Landscape (992px y menos) */
@media screen and (max-width: 992px) {
  .main-content {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }

  .filters-section,
  .controls-section {
    width: 100% !important;
    max-width: none;
  }

  .filter-row {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .date-inputs {
    width: 100%;
  }

  .image-drop-area {
    width: 100%;
    max-width: none;
  }

  .filter-group {
    width: 100%;
  }

  .date-group {
    width: 100%;
  }

  .button-group {
    width: 100%;
    justify-content: space-between;
  }

  .header-footer-btn {
    width: 100%;
  }
}

/* Tablet Portrait (768px y menos) */
@media screen and (max-width: 768px) {
  .main-content {
    padding: 0;
  }

  .filter-row {
    flex-direction: column;
  }

  .filter-group {
    width: 100%;
  }

  .date-inputs {
    flex-direction: column;
  }

  .date-buttons {
    flex-direction: column;
  }

  .date-btn {
    width: 100%;
  }

  .button-group {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .btn {
    flex: 1 1 calc(33.33% - 0.5rem);
    margin: 0.25rem;
  }

  .report-wrapper {
    padding: 1rem;
  }

  .date-inputs {
    flex-direction: column;
    width: 100%;
  }

  .date-field {
    width: 100%;
  }

  .filters-section,
  .controls-section {
    width: 100%;
  }

  .table-container {
    width: 100%;
    overflow-x: auto;
  }

  table,
  .modern-table,
  .fiscal-table {
    min-width: 100%;
  }

  .modern-table th,
  .modern-table td,
  .fiscal-table th,
  .fiscal-table td {
    padding: 0.5rem;
    font-size: 0.875rem;
  }

  .fiscal-main-header th,
  .fiscal-sub-header th {
    font-size: 0.75rem;
    padding: 0.5rem;
  }

  .chart-container {
    padding: 1rem;
  }

  .resumen-grid,
  .resumen-grid-fiscal {
    grid-template-columns: 1fr;
  }

  .resumen-fiscal .resumen-item.total-general {
    grid-column: span 1;
  }

  /* Modal responsive */
  .modal-container {
    width: 95%;
    max-height: 90vh;
  }

  .modal-header {
    padding: 1rem;
  }

  .modal-body {
    padding: 1rem;
  }

  .modal-footer {
    padding: 1rem;
    flex-direction: column;
  }

  .ventas-canceladas-summary,
  .desglose-grid {
    grid-template-columns: 1fr;
  }

  .summary-item,
  .desglose-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
}

/* Mobile (576px y menos) */
@media screen and (max-width: 576px) {
  .button-group {
    flex-direction: column;
  }

  .btn,
  .header-footer-btn {
    width: 100%;
    margin: 0.25rem 0;
  }

  .filters-section,
  .controls-section {
    width: 100%;
  }

  .header-footer-btn,
  .date-btn {
    width: 100%;
  }

  .totals {
    width: 100%;
  }

  .totals div {
    width: 100%;
  }

  .modern-table th,
  .modern-table td {
    padding: 0.5rem 0.25rem;
    font-size: 0.8rem;
  }

  .product-info,
  .client-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .rank {
    align-self: flex-start;
  }
}

/* Extra Small (400px y menos) */
@media screen and (max-width: 400px) {
  .report-wrapper {
    padding: 0.5rem;
  }

  .filters-section,
  .controls-section {
    width: 100%;
  }

  .report-body {
    width: 100%;
  }

  thead th,
  tbody td {
    padding: 0.5rem;
    font-size: 0.875rem;
  }

  .modern-table,
  .fiscal-table {
    font-size: 0.75rem;
  }

  .modern-table th,
  .modern-table td,
  .fiscal-table th,
  .fiscal-table td {
    padding: 0.4rem 0.2rem;
  }
}

/* Print Media Query */
@media print {
  .report-wrapper {
    padding: 0;
  }

  .filters-section,
  .controls-section,
  .button-group,
  .checkbox-container,
  .ventas-anuladas-section {
    display: none;
  }

  .table-container {
    margin: 0;
    padding: 0;
    width: 100%;
  }

  table,
  .modern-table,
  .fiscal-table {
    border: 1px solid #000;
  }

  thead th {
    background-color: #f5f5f5 !important;
    color: #000 !important;
    -webkit-print-color-adjust: exact;
  }

  .totals,
  .resumen-totales,
  .resumen-fiscal {
    margin-top: 1rem;
    page-break-inside: avoid;
  }

  .chart-container {
    display: none;
  }
}

/* Scrollbar personalizado */
.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Scrollbar en modo oscuro */
.dark .table-container::-webkit-scrollbar-track {
  background: #2d2d2d;
}

.dark .table-container::-webkit-scrollbar-thumb {
  background: #c09d62;
}

.dark .table-container::-webkit-scrollbar-thumb:hover {
  background: #a38655;
}


/* ===============================================
   ESTILOS PARA FACTURAS SIN SAR
=============================================== */

.facturas-sin-sar-container {
  margin-top: 2rem;
}

.alert-warning-sar {
  background: linear-gradient(135deg, #fff3cd, #ffe69c);
  border: 2px solid #ffc107;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);
}

.alert-warning-sar i {
  font-size: 2rem;
  color: #ff9800;
}

.alert-warning-sar strong {
  color: #d68910;
}

.numero-temporal {
  font-family: 'Courier New', monospace;
  font-weight: 700;
  color: #ff9800;
  font-size: 1.1rem;
  white-space: nowrap;
}

.numero-temporal i {
  margin-right: 0.5rem;
  font-size: 1.2rem;
}

.badge-estado {
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.badge-pendiente {
  background: #ffc107;
  color: #212529;
}

.badge-pagada {
  background: #28a745;
  color: white;
}

.monto-total {
  font-weight: 700;
  color: #ff9800;
  font-size: 1.05rem;
}

.resumen-sin-sar {
  margin-top: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #fff8e1, #ffecb3);
  border-radius: 8px;
  border: 2px solid #ffc107;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);
}

.resumen-sin-sar .resumen-titulo {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #f57c00;
  text-align: center;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.resumen-sin-sar .resumen-titulo i {
  font-size: 1.5rem;
}

.resumen-valor-sar {
  font-size: 1.4rem;
  font-weight: 700;
  color: #f57c00;
}

.resumen-sin-sar .resumen-item.total-general-sar {
  grid-column: span 2;
  background: linear-gradient(135deg, #ff9800, #f57c00);
  color: white;
}

.resumen-sin-sar .resumen-item.total-general-sar .resumen-label,
.resumen-sin-sar .resumen-item.total-general-sar .resumen-valor {
  color: white;
}

/* Modo oscuro */
.dark .alert-warning-sar {
  background: linear-gradient(135deg, #3d3000, #5a4500);
  border-color: #ffc107;
}

.dark .alert-warning-sar strong {
  color: #ffca28;
}

.dark .resumen-sin-sar {
  background: linear-gradient(135deg, #3d3000, #5a4500);
  border-color: #ffc107;
}

.dark .resumen-sin-sar .resumen-titulo {
  color: #ffca28;
}

/* ===============================================
   ESTILOS PARA REPORTES AMPLIADOS (integrados)
=============================================== */

.amp-summary-totales {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.amp-card-tot {
  flex: 1;
  min-width: 160px;
  background: #f8f9fa;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.amp-card-tot span { font-size: 0.8rem; color: #6c757d; }
.amp-card-tot strong { font-size: 1.1rem; font-weight: 700; color: #212529; }
.amp-highlight { border-color: #c09d62; background: #fffaf2; }
.amp-highlight strong { color: #c09d62; }
.amp-highlight-green { border-color: #28a745; background: #f0fff4; }
.amp-highlight-green strong { color: #155724; }
.amp-highlight-yellow { border-color: #ffc107; background: #fffef0; }
.amp-highlight-yellow strong { color: #856404; }
.amp-highlight-red { border-color: #dc3545; background: #fff5f5; }
.amp-highlight-red strong { color: #721c24; }

.amp-fila-total { background: #f8f9fa !important; font-weight: 700; border-top: 2px solid #dee2e6; }
.amp-fila-total td { color: #212529 !important; }

.amp-info-box {
  background: #e8f4fd;
  border: 1px solid #bee3f8;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 0.9rem;
  color: #2c5282;
}

.row-alerta td { background: #fff5f5 !important; }

.badge-amp-success { background: #d1e7dd; color: #0f5132; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; }
.badge-amp-warning { background: #fff3cd; color: #856404; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; }
.badge-amp-danger  { background: #f8d7da; color: #842029; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; }
.badge-amp-info    { background: #cff4fc; color: #055160; padding: 2px 8px; border-radius: 12px; font-size: 0.75rem; font-weight: 600; }

.fila-proyectada td { background: #fffbeb !important; font-style: italic; }
.dark .fila-proyectada td { background: #2d2500 !important; }

.amp-comparativo-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.amp-mes-card {
  flex: 1;
  min-width: 160px;
  background: #f8f9fa;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px;
}

.amp-mes-nombre { font-weight: 700; font-size: 0.875rem; color: #495057; margin-bottom: 6px; }
.amp-mes-stat { display: flex; justify-content: space-between; font-size: 0.8rem; color: #6c757d; margin-bottom: 2px; }
.amp-mes-stat strong { color: #212529; }

.amp-mes-bar-wrap { background: #e9ecef; border-radius: 4px; height: 6px; margin-top: 8px; overflow: hidden; }
.amp-mes-bar { height: 100%; background: #c09d62; border-radius: 4px; transition: width 0.5s; }

</style>
